import {
  DRAFT_ROOT,
  FirestoreDocPathSchema,
  aiHelpCollection,
  aiTasksCollection,
  appBrandSearchIndexPath,
  appCollection,
  appDefaultEquipmentGuidePath,
  appEquipmentConfigObjectsCollection,
  appEquipmentConfigPath,
  appNotificationConfigPath,
  appRecallsStatePath,
  appStatusCollection,
  appStatusDocPath,
  appTaskScreenConfigPath,
  appUserLimitsConfigPath,
  appliesToDraftResultPath,
  appliesToDraftResultsCollection,
  brandAliasPath,
  brandAliasesCollection,
  brandMergePath,
  brandMergesCollection,
  brandPath,
  brandRequestPath,
  brandRequestsCollection,
  brandResearchCollection,
  brandResearchPath,
  brandSourcePath,
  brandSourcesCollection,
  brandsCollection,
  chatConversationPath,
  chatConversationsCollection,
  companiesCollection,
  companyPath,
  considerationDocPath,
  considerationDocsCollection,
  considerationPath,
  considerationTypePath,
  considerationTypesCollection,
  considerationsCollection,
  considerationsCollectionGroupName,
  contactPath,
  contactsCollection,
  contactsCollectionGroupName,
  customEquipmentTypePath,
  customEquipmentTypesCollection,
  customEquipmentTypesCollectionGroupName,
  customTaskTypePath,
  customTaskTypesCollection,
  customTaskTypesCollectionGroupName,
  devicesCollectionGroupName,
  documentCoverageCollection,
  documentCoveragePath,
  documentSearchPath,
  documentSearchesCollection,
  domainEventPath,
  domainEventsCollection,
  draftFlowPath,
  draftFlowsCollection,
  equipmentCollection,
  equipmentCollectionGroupName,
  equipmentImageSearchRequestPath,
  equipmentImageSearchRequestsCollection,
  equipmentLearnRequestPath,
  equipmentLearnRequestsCollection,
  equipmentPath,
  equipmentRefreshPath,
  equipmentRefreshesCollection,
  equipmentTestLibraryCollection,
  equipmentTestLibraryEntryPath,
  equipmentTypeCandidatePath,
  equipmentTypeCandidatesCollection,
  equipmentTypeFamiliesCollection,
  equipmentTypeFamilyPath,
  equipmentTypeObjectsCollection,
  equipmentTypePath,
  equipmentTypeRefreshPath,
  equipmentTypeRefreshesCollection,
  equipmentTypesCollection,
  feedbackCollection,
  feedbackEntryPath,
  folderPath,
  foldersCollection,
  fromDraftPath,
  guideHelpCacheCollection,
  guideHelpCacheEntryPath,
  guideHelpRequestPath,
  guideHelpRequestsCollection,
  guidePath,
  guideStarterPath,
  guideStartersCollection,
  guideStartersCollectionGroupName,
  guideVisitPath,
  guideVisitsCollection,
  homeEvalJobRunPath,
  homeEvalJobRunsCollection,
  homeEvalResultPath,
  homeEvalResultsCollection,
  homeEvalTriggerPath,
  homeEvalTriggersCollection,
  homeInvitePath,
  homeInvitesCollection,
  homeInvitesCollectionGroupName,
  homeMemberPath,
  homeMembersCollection,
  homePath,
  homeQuestionPath,
  homeQuestionsCollection,
  homeRecentlyViewedCollection,
  homeRecentlyViewedPath,
  homeSpacePath,
  homeSpacesCollection,
  homeTaskSubscriptionPath,
  homeTaskSubscriptionsCollection,
  homesCollection,
  infoTypePath,
  infoTypesCollection,
  jobsCollection,
  learnCacheCollection,
  learnCacheEntryPath,
  legacyRecallVerdictPath,
  lessonDocPath,
  lessonDocsCollection,
  lessonPath,
  lessonTypePath,
  lessonTypesCollection,
  lessonsCollection,
  lessonsCollectionGroupName,
  modelDetailsCollection,
  modelDocumentCandidatePath,
  modelDocumentCandidatesCollection,
  modelDocumentCandidatesCollectionGroupName,
  modelDocumentPath,
  modelDocumentsCollection,
  modelNumberHelpCacheCollection,
  modelNumberHelpCacheEntryPath,
  modelNumberHelpRequestPath,
  modelNumberHelpRequestsCollection,
  modelPath,
  modelSpellingPath,
  modelSpellingsCollection,
  modelsCollection,
  notificationConfigCollection,
  notificationConfigCollectionGroupName,
  notificationConfigPath,
  notificationPath,
  notificationsCollection,
  notionWebhookEventPath,
  notionWebhookEventsCollection,
  planReviewPath,
  planReviewsCollection,
  processHowOftenResultPath,
  processHowOftenResultsCollection,
  propertyLookupRequestPath,
  propertyLookupRequestsCollection,
  pushReceiptsCollectionGroupName,
  recallJobPath,
  recallJobsCollection,
  recallKeyPath,
  recallKeysCollection,
  recallMatchPath,
  recallMatchesCollection,
  recallMatchesCollectionGroupName,
  recallPath,
  recallTopicPath,
  recallTopicsCollection,
  recallVerdictPath,
  recallVerdictsCollection,
  recallVerdictsCollectionGroupName,
  recallsCollection,
  resetStatePath,
  rockDocPath,
  rockDocsCollection,
  rockManualsJobRunPath,
  rockManualsJobRunsCollection,
  roomEnhancementPath,
  roomEnhancementsCollection,
  roomPath,
  roomsCollection,
  sharedNameplatePath,
  sharedNameplatesCollection,
  spaceFlowPath,
  spaceObjectsCollection,
  spacePath,
  spacesCollection,
  systemCollection,
  systemInfoCollection,
  systemInfoPath,
  taskDocPath,
  taskDocsCollection,
  taskGenerationJobRunPath,
  taskGenerationJobRunsCollection,
  taskPath,
  taskSubscriptionsCollectionGroupName,
  taskTypePath,
  taskTypesCollection,
  tasksCollection,
  tasksCollectionGroupName,
  toDraftPath,
  userAuthEventsCollection,
  userDevicePath,
  userDevicesCollection,
  userLimitsCollection,
  userLimitsPath,
  userNotificationEmailReceiptPath,
  userNotificationEmailReceiptsCollection,
  userNotificationPath,
  userNotificationPushReceiptPath,
  userNotificationPushReceiptsCollection,
  userNotificationsCollection,
  userPath,
  userRolesCollection,
  userRolesPath,
  userTaskScreenConfigCollection,
  userTaskScreenConfigPath,
  usersCollection,
  weekendFillPath,
  weekendFillsCollection
} from "./chunk-QM34SWEU.js";

// src/compareAndSet.ts
function matchesExpected(data, expect) {
  return Object.entries(expect).every(([field, value]) => Object.is(data[field], value));
}

// src/context.ts
var ctx;
function initializeDao(config) {
  ctx = config;
}
function getDaoContext() {
  if (!ctx) throw new Error("Call initializeDao() before using DAOs");
  return ctx;
}

// src/adapter.ts
var MAX_BATCH_WRITES = 500;

// src/BaseDao.ts
var BaseDao = class {
  adapter;
  log;
  constructor(loggerName) {
    const { adapter, loggerFactory } = getDaoContext();
    this.adapter = adapter;
    this.log = loggerFactory(loggerName);
  }
  // Thin pass-throughs so subclasses write data without importing the Firestore SDK
  // directly. The concrete adapter (per surface) owns the durability policy: db-native
  // is fire-and-forget; db-admin and db-server await. Routing every write through here
  // is what the db-native usage-check fences against bypassing.
  getDoc(path) {
    return this.adapter.getDoc(path);
  }
  setDoc(path, data, options) {
    return this.adapter.setDoc(path, data, options);
  }
  updateDoc(path, updates) {
    return this.adapter.updateDoc(path, updates);
  }
  /** Guarded, atomic update — see `DbAdapter.compareAndSetDoc`. Resolves false if the guard failed. */
  compareAndSetDoc(path, args) {
    return this.adapter.compareAndSetDoc(path, args);
  }
  /** Atomic multi-doc write — see `DbAdapter.commitBatch`. */
  commitBatch(writes) {
    return this.adapter.commitBatch(writes);
  }
  /**
   * `commitBatch` past the cap: one batch per `MAX_BATCH_WRITES`, committed in order, so a plan too
   * big for one batch loses atomicity across batches but keeps its write order.
   */
  async commitInBatches(writes) {
    for (let start = 0; start < writes.length; start += MAX_BATCH_WRITES) {
      await this.commitBatch(writes.slice(start, start + MAX_BATCH_WRITES));
    }
  }
  addDoc(collectionPath, data, options) {
    return this.adapter.addDoc(collectionPath, data, options);
  }
  deleteDoc(path) {
    return this.adapter.deleteDoc(path);
  }
  deleteFieldValue() {
    return this.adapter.deleteFieldValue();
  }
  arrayUnionValue(...values) {
    return this.adapter.arrayUnionValue(...values);
  }
  arrayRemoveValue(...values) {
    return this.adapter.arrayRemoveValue(...values);
  }
  /**
   * Flattens a patch into Firestore field paths — the shape every `update*` on this layer writes.
   *
   * Two things an update can't express on its own, both of which have bitten us:
   *  - A key set to `undefined` is SILENTLY DROPPED (`ignoreUndefinedProperties`), leaving the old
   *    value in place. Here it becomes a delete, so "set this to nothing" means it.
   *  - A nested object REPLACES the stored one, taking its untouched siblings with it. Here it is
   *    flattened (`display.calendar.firstWeekday`), so two writers owning different keys of the
   *    same group can't erase each other.
   *
   * Arrays are values, not groups — there is no sensible per-index merge, so they are replaced
   * whole (use `arrayUnionValue` when appending is what you mean). Class instances (`Date`, a
   * `FieldValue` sentinel) are values too. `prefix` roots the paths under an existing field, which
   * is how a map entry patches one of its own keys (`images.{id}.rotation`).
   *
   * The caveat worth knowing: an empty object flattens to nothing, so this cannot SET a field to
   * an empty map — it writes no key at all. Every group we patch is a bag of optional keys where
   * that reads as "nothing to change", but reach for `setDoc` if you ever need the empty map.
   */
  toFieldPaths(updates, prefix = "") {
    const out = {};
    for (const [key, value] of Object.entries(updates)) {
      const fieldPath = prefix ? `${prefix}.${key}` : key;
      if (value === void 0) {
        out[fieldPath] = this.deleteFieldValue();
      } else if (isPlainObject(value)) {
        Object.assign(out, this.toFieldPaths(value, fieldPath));
      } else {
        out[fieldPath] = value;
      }
    }
    return out;
  }
};
function isPlainObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value) && Object.getPrototypeOf(value) === Object.prototype;
}

// src/parseWithSchema.ts
function parseWithSchema(data, schema, path, log) {
  if (!data) {
    return void 0;
  }
  const result = schema.safeDecode(data);
  if (result.success) {
    return result.data;
  }
  const pathString = typeof path === "function" ? `/${path()}` : `/${path}`;
  (log || console).error(
    `Schema validation failed at path: ${pathString}${typeof process !== "undefined" && process.env?.EXPO_PUBLIC_ROCK_APP_ENV === "local" ? ` issues: ${JSON.stringify(result.error.issues, null, 2)}` : ""}`,
    { issues: result.error.issues, path: pathString, rawData: data }
  );
  return void 0;
}

// src/withExpireAt.ts
var MS_PER_DAY = 24 * 60 * 60 * 1e3;
var LIVE_RETENTION_DAYS = 90;
function withExpireAt(data, now = /* @__PURE__ */ new Date()) {
  return { ...data, expireAt: liveRetentionEnd(now.getTime()) };
}
function liveRetentionEnd(lastWriteMs) {
  return new Date(lastWriteMs + LIVE_RETENTION_DAYS * MS_PER_DAY);
}

// src/dao/BaseAppliesToDraftResultDao.ts
import { AppliesToDraftResultSchema } from "@rock/types";
var BaseAppliesToDraftResultDao = class extends BaseDao {
  constructor() {
    super("AppliesToDraftResultDao");
  }
  async getAppliesToDraftResult(resultId) {
    const path = appliesToDraftResultPath(resultId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, AppliesToDraftResultSchema, path, this.log) : void 0;
  }
  async setAppliesToDraftResult(resultId, data) {
    const path = appliesToDraftResultPath(resultId);
    this.log.info("Setting AppliesToDraftResult", { path });
    await this.adapter.setDoc(path, data);
  }
};

// src/dao/BaseAppStatusDao.ts
import { APP_STATUS_DOC_SCHEMAS } from "@rock/types";

// src/dao/BaseDraftableDao.ts
function hasUnpublishedChanges(status) {
  return status === "draft-pending" || status === "draft-differs";
}
function stampDraft(doc) {
  return { ...doc, _draft: true };
}
function stripDraft(doc) {
  const copy = { ...doc };
  delete copy._draft;
  return copy;
}
function deepEqual(a, b) {
  if (a === b) return true;
  if (a === null || b === null || typeof a !== "object" || typeof b !== "object") return false;
  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
    return a.every((item, i) => deepEqual(item, b[i]));
  }
  const aObj = a;
  const bObj = b;
  const aKeys = Object.keys(aObj);
  const bKeys = Object.keys(bObj);
  if (aKeys.length !== bKeys.length) return false;
  return aKeys.every((k) => Object.hasOwn(bObj, k) && deepEqual(aObj[k], bObj[k]));
}
function computeDraftStatus(draft, live, ignoreFields = []) {
  if (!draft) return "no-draft";
  if (!live) return "draft-pending";
  const strip = (obj) => {
    const copy = stripDraft(obj);
    for (const field of ignoreFields) delete copy[field];
    return copy;
  };
  return deepEqual(strip(draft), strip(live)) ? "in-sync" : "draft-differs";
}
var DraftLayer = class {
  opts;
  constructor(opts) {
    this.opts = opts;
  }
  getDraft(livePath) {
    return this.read(toDraftPath(livePath));
  }
  async setDraft(livePath, data) {
    const draftPath = toDraftPath(livePath);
    this.opts.log.info("Setting draft", { draftPath });
    await this.opts.adapter.setDoc(draftPath, stampDraft(data));
  }
  async discardDraft(livePath) {
    const draftPath = toDraftPath(livePath);
    this.opts.log.info("Discarding draft", { draftPath });
    await this.opts.adapter.deleteDoc(draftPath);
  }
  /** Copies the live doc into the draft slot if no draft exists yet, so the admin edits a full copy. */
  async seedDraftFromLive(livePath) {
    const draftPath = toDraftPath(livePath);
    const existing = await this.read(draftPath);
    if (existing) return existing;
    const live = await this.read(livePath);
    if (!live) return void 0;
    const seeded = stampDraft(live);
    await this.opts.adapter.setDoc(draftPath, seeded);
    return seeded;
  }
  /**
   * Promotes the draft to live. Reconciles with the existing live doc via `mergeOnPublish`, strips
   * the `_draft` flag, writes the result to live, deletes the mirror doc, and returns the published
   * doc. Publish is the single strip point: live docs never carry `_draft`.
   */
  async publish(livePath) {
    const draftPath = toDraftPath(livePath);
    const draft = await this.read(draftPath);
    if (!draft) throw new Error(`No draft to publish at ${draftPath}`);
    const live = await this.read(livePath);
    const merged = stripDraft(this.opts.mergeOnPublish ? this.opts.mergeOnPublish(draft, live) : draft);
    this.opts.log.info("Publishing draft", { livePath, draftPath });
    await this.opts.adapter.setDoc(livePath, merged);
    await this.opts.adapter.deleteDoc(draftPath);
    return merged;
  }
  async status(livePath) {
    const [draft, live] = await Promise.all([this.read(toDraftPath(livePath)), this.read(livePath)]);
    return computeDraftStatus(draft, live, this.opts.diffIgnoreFields);
  }
  async read(path) {
    const data = await this.opts.adapter.getDoc(path);
    return data ? parseWithSchema(data, this.opts.schema, path, this.opts.log) : void 0;
  }
};

// src/dao/BaseAppStatusDao.ts
var BaseAppStatusDao = class extends BaseDao {
  drafts;
  constructor() {
    super("AppStatusDao");
    const layer = (kind) => new DraftLayer({
      adapter: this.adapter,
      log: this.log,
      schema: APP_STATUS_DOC_SCHEMAS[kind],
      // Publish restamps updatedAt (below), so it must not read as an unpublished change.
      diffIgnoreFields: ["updatedAt"],
      mergeOnPublish: (draft) => restampUpdatedAt(draft)
    });
    this.drafts = {
      alert: layer("alert"),
      "required-upgrade": layer("required-upgrade"),
      "eas-update": layer("eas-update"),
      maintenance: layer("maintenance"),
      "store-urls": layer("store-urls")
    };
  }
  async getAppStatusDoc(kind) {
    const path = appStatusDocPath(kind);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, APP_STATUS_DOC_SCHEMAS[kind], path, this.log) : void 0;
  }
  getAppStatusDraft(kind) {
    return this.drafts[kind].getDraft(appStatusDocPath(kind));
  }
  setAppStatusDraft(kind, doc) {
    return this.drafts[kind].setDraft(appStatusDocPath(kind), doc);
  }
  discardAppStatusDraft(kind) {
    return this.drafts[kind].discardDraft(appStatusDocPath(kind));
  }
  /** Promotes the draft to live (restamping `updatedAt` to publish time) and deletes the mirror doc. */
  publishAppStatus(kind) {
    return this.drafts[kind].publish(appStatusDocPath(kind));
  }
  appStatusDraftStatus(kind) {
    return this.drafts[kind].status(appStatusDocPath(kind));
  }
};
function restampUpdatedAt(doc) {
  return Object.assign({}, doc, { updatedAt: (/* @__PURE__ */ new Date()).toISOString() });
}

// src/dao/BaseBrandAliasDao.ts
import { BrandAliasSchema } from "@rock/types";
var BaseBrandAliasDao = class extends BaseDao {
  constructor() {
    super("BrandAliasDao");
  }
  async getBrandAlias(aliasKey) {
    const path = brandAliasPath(aliasKey);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, BrandAliasSchema, path, this.log) : void 0;
  }
  async setBrandAlias(aliasKey, data) {
    const path = brandAliasPath(aliasKey);
    this.log.info("Setting BrandAlias", { path });
    await this.adapter.setDoc(path, data);
  }
  /** The brand merge's per-key repoint; plan-shaped removals go through `BrandDao` and `SharedNameplateDao`. */
  async deleteBrandAlias(aliasKey) {
    const path = brandAliasPath(aliasKey);
    this.log.info("Deleting BrandAlias", { path });
    await this.adapter.deleteDoc(path);
  }
  async updateBrandAlias(aliasKey, updates) {
    const path = brandAliasPath(aliasKey);
    this.log.info("Updating BrandAlias", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseBrandDao.ts
import { resolveLiveBrand } from "@rock/brands";
import { BrandSchema } from "@rock/types";

// src/dao/brandAliasWrites.ts
function setAliasWrite(alias) {
  return { kind: "set", path: brandAliasPath(alias.id), data: alias };
}
function deleteAliasWrite(key) {
  return { kind: "delete", path: brandAliasPath(key) };
}

// src/dao/BaseBrandDao.ts
var BaseBrandDao = class extends BaseDao {
  constructor() {
    super("BrandDao");
  }
  async getBrand(brandId) {
    const path = brandPath(brandId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, BrandSchema, path, this.log) : void 0;
  }
  /**
   * The brand an id names TODAY (`resolveLiveBrand` from `@rock/brands`, at most `MAX_BRAND_MERGE_HOPS`): a
   * merged brand followed to its winner, a junk brand nothing (its keys are free to every resolver), and a
   * chain too long to follow nothing rather than a brand that was merged away. The one rule every
   * resolver, automated or admin, goes through.
   */
  async getLiveBrand(brandId) {
    return resolveLiveBrand(brandId, (id) => this.getBrand(id));
  }
  async setBrand(brandId, data) {
    const path = brandPath(brandId);
    this.log.info("Setting Brand", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateBrand(brandId, updates) {
    const path = brandPath(brandId);
    this.log.info("Updating Brand", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /** Admin-only curation status change — never called by Brandfetch or any other automated writer. */
  async setBrandReviewStatus(brandId, reviewStatus, now, statusNote) {
    const path = brandPath(brandId);
    const note = statusNote?.trim();
    this.log.info("Setting Brand review status", { path, reviewStatus, statusNote: note });
    await this.adapter.updateDoc(path, {
      reviewStatus,
      statusNote: note || this.deleteFieldValue(),
      statusChangedAt: now,
      updatedAt: now
    });
  }
  // The `brand-aliases/{key}` projections are part of the brand aggregate — a brand whose alias docs are
  // missing (or stale docs pointing at a removed alias) silently breaks name resolution. So the mutations
  // that touch them are applied HERE, as one batch where the plan fits (see `commitInBatches`), from plans
  // computed by `@rock/brands` (`planBrand*`). The plan parameters are typed structurally so this
  // data-layer package needs no domain-package import.
  /** Apply a `@rock/brands` creation plan: the brand doc plus its alias lookup projections. */
  async applyBrandCreation(plan) {
    const path = brandPath(plan.brand.id);
    this.log.info("Creating Brand with alias projections", { path, aliasCount: plan.aliases.length });
    await this.commitInBatches([{ kind: "set", path, data: plan.brand }, ...plan.aliases.map(setAliasWrite)]);
  }
  /** Apply a `@rock/brands` alias-addition plan: new alias docs plus the brand's display list. */
  async applyBrandAliasAddition(brandId, plan, now) {
    const path = brandPath(brandId);
    this.log.info("Adding Brand alias", { path, keys: plan.aliasDocs.map((a) => a.id) });
    await this.commitInBatches([
      ...plan.aliasDocs.map(setAliasWrite),
      { kind: "update", path, updates: { aliases: plan.brandAliases, updatedAt: now } }
    ]);
  }
  /**
   * Apply a `@rock/brands` line-addition plan: the line's alias docs, then the brand's `lines` (and its
   * `aliases` when an alias was absorbed into the line) in one write. Every intermediate state still
   * resolves each name to the brand.
   */
  async applyBrandLineAddition(brandId, plan, now) {
    const path = brandPath(brandId);
    this.log.info("Adding Brand line", { path, keys: plan.aliasDocs.map((a) => a.id) });
    await this.commitInBatches([
      ...plan.aliasDocs.map(setAliasWrite),
      {
        kind: "update",
        path,
        updates: {
          lines: plan.brandLines,
          ...plan.brandAliases ? { aliases: plan.brandAliases } : {},
          updatedAt: now
        }
      }
    ]);
  }
  /** Rename a line's display name; its id (and keys) stay. */
  async setBrandLines(brandId, lines, now) {
    const path = brandPath(brandId);
    this.log.info("Setting Brand lines", { path, count: lines.length });
    await this.adapter.updateDoc(path, { lines, updatedAt: now });
  }
  /** Apply a `@rock/brands` line-removal plan: delete the line's alias docs, then drop it from `lines`. */
  async applyBrandLineRemoval(brandId, plan, now) {
    const path = brandPath(brandId);
    this.log.info("Removing Brand line", { path, keys: plan.deleteKeys });
    await this.commitInBatches([
      ...plan.deleteKeys.map(deleteAliasWrite),
      { kind: "update", path, updates: { lines: plan.brandLines, updatedAt: now } }
    ]);
  }
  /** Apply a `@rock/brands` alias-removal plan: delete alias docs, then shrink the display list. */
  async applyBrandAliasRemoval(brandId, plan, now) {
    const path = brandPath(brandId);
    this.log.info("Removing Brand alias", { path, keys: plan.deleteKeys });
    await this.commitInBatches([
      ...plan.deleteKeys.map(deleteAliasWrite),
      { kind: "update", path, updates: { aliases: plan.brandAliases, updatedAt: now } }
    ]);
  }
};

// src/dao/BaseBrandMergeDao.ts
import { BrandMergeSchema } from "@rock/types";
var BaseBrandMergeDao = class extends BaseDao {
  constructor() {
    super("BrandMergeDao");
  }
  async getBrandMerge(mergeId) {
    const path = brandMergePath(mergeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, BrandMergeSchema, path, this.log) : void 0;
  }
  async setBrandMerge(merge) {
    const path = brandMergePath(merge.id);
    this.log.info("Setting BrandMerge", { path, loserId: merge.loserId, winnerId: merge.winnerId });
    await this.adapter.setDoc(path, merge);
  }
  async updateBrandMerge(mergeId, updates) {
    const path = brandMergePath(mergeId);
    this.log.info("Updating BrandMerge", { path, status: updates.status });
    await this.adapter.updateDoc(path, this.toFieldPaths(updates));
  }
};

// src/dao/BaseBrandSourceDao.ts
import { BrandSourceSchema } from "@rock/types";
var BaseBrandSourceDao = class extends BaseDao {
  constructor() {
    super("BrandSourceDao");
  }
  async getBrandSource(brandId, sourceId) {
    const path = brandSourcePath(brandId, sourceId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, BrandSourceSchema, path, this.log) : void 0;
  }
  async setBrandSource(source) {
    const path = brandSourcePath(source.brandId, source.id);
    this.log.info("Setting BrandSource snapshot", { path, domain: source.domain });
    await this.adapter.setDoc(path, source);
  }
};

// src/dao/BaseBrandRequestDao.ts
import { BrandRequestSchema } from "@rock/types";
var BaseBrandRequestDao = class extends BaseDao {
  constructor() {
    super("BrandRequestDao");
  }
  async getBrandRequest(requestId) {
    const path = brandRequestPath(requestId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, BrandRequestSchema, path, this.log) : void 0;
  }
  async setBrandRequest(requestId, data) {
    const path = brandRequestPath(requestId);
    this.log.info("Setting BrandRequest", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateBrandRequest(requestId, updates) {
    const path = brandRequestPath(requestId);
    this.log.info("Updating BrandRequest", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /** A brand merge: a request that resolved to the loser (through either field) now names the winner. */
  async repointResolvedBrand(request, from, to) {
    const path = brandRequestPath(request.id);
    this.log.info("Repointing BrandRequest brand", { path, from, to });
    await this.adapter.updateDoc(path, {
      ...request.canonicalBrandId === from ? { canonicalBrandId: to } : {},
      ...request.resolution?.brandId === from ? { "resolution.brandId": to } : {}
    });
  }
  /**
   * A human's decision on an open request. The catalog writes it implies (a new brand, an alias) are
   * applied by the caller BEFORE this, so the `handleBrandRequest` fan-out finds a brand that resolves.
   */
  async resolveBrandRequest(requestId, resolution, now) {
    const path = brandRequestPath(requestId);
    this.log.info("Resolving BrandRequest", { path, kind: resolution.kind, brandId: resolution.brandId });
    await this.adapter.updateDoc(path, { status: "resolved", resolution, updatedAt: now });
  }
  /**
   * A human sets a pending name aside; `applyBrandRequestSighting` brings it back when it is seen again.
   * False when the request is no longer pending: a resolution landing first must not be overwritten.
   */
  async parkBrandRequest(requestId, by, now) {
    const path = brandRequestPath(requestId);
    const parked = await this.compareAndSetDoc(path, {
      expect: { status: "pending" },
      updates: { status: "parked", parked: { by, at: now }, updatedAt: now }
    });
    this.log.info(parked ? "Parked BrandRequest" : "BrandRequest no longer pending; not parked", { path, by });
    return parked;
  }
  /** Back to the queue by hand. False when the request is no longer parked. */
  async unparkBrandRequest(requestId, now) {
    const path = brandRequestPath(requestId);
    const unparked = await this.compareAndSetDoc(path, {
      expect: { status: "parked" },
      updates: { status: "pending", parked: this.deleteFieldValue(), updatedAt: now }
    });
    this.log.info(unparked ? "Unparked BrandRequest" : "BrandRequest no longer parked; not unparked", { path });
    return unparked;
  }
};

// src/dao/BaseBrandResearchDao.ts
import { BrandResearchSchema } from "@rock/types";
var BaseBrandResearchDao = class extends BaseDao {
  constructor() {
    super("BrandResearchDao");
  }
  async getBrandResearch(requestId, researchId) {
    const path = brandResearchPath(requestId, researchId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, BrandResearchSchema, path, this.log) : void 0;
  }
  async setBrandResearch(research) {
    const path = brandResearchPath(research.requestId, research.id);
    this.log.info("Setting BrandResearch", { path, status: research.status });
    await this.adapter.setDoc(path, research);
  }
  /**
   * Take a `requested` run for this trigger event, atomically: false when another delivery of the event (or
   * anything else) already moved it on, so the paid work runs once.
   */
  async claimBrandResearch(requestId, researchId, claim) {
    const path = brandResearchPath(requestId, researchId);
    const claimed = await this.compareAndSetDoc(path, {
      expect: { status: "requested" },
      updates: { status: "running", ...claim }
    });
    this.log.info(claimed ? "Claimed BrandResearch" : "BrandResearch already claimed", { path });
    return claimed;
  }
  async updateBrandResearch(requestId, researchId, updates) {
    const path = brandResearchPath(requestId, researchId);
    this.log.info("Updating BrandResearch", { path, status: updates.status });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseBrandSearchIndexDao.ts
import { BrandSearchIndexSchema } from "@rock/types";
var BaseBrandSearchIndexDao = class extends BaseDao {
  constructor() {
    super("BrandSearchIndexDao");
  }
  async getBrandSearchIndex() {
    const path = appBrandSearchIndexPath();
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, BrandSearchIndexSchema, path, this.log) : void 0;
  }
  async setBrandSearchIndex(index) {
    const path = appBrandSearchIndexPath();
    this.log.info("Setting Brand search index", { path, entryCount: index.entries.length });
    await this.adapter.setDoc(path, index);
  }
};

// src/dao/BaseChatConversationDao.ts
import { ChatConversationSchema } from "@rock/types";
var BaseChatConversationDao = class extends BaseDao {
  constructor() {
    super("ChatConversationDao");
  }
  async getConversation(userId, conversationId) {
    const path = chatConversationPath(userId, conversationId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ChatConversationSchema, path, this.log) : void 0;
  }
  async setConversation(userId, conversationId, data) {
    const path = chatConversationPath(userId, conversationId);
    this.log.info("Setting ChatConversation", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateConversation(userId, conversationId, updates) {
    const path = chatConversationPath(userId, conversationId);
    this.log.info("Updating ChatConversation", { path });
    await this.adapter.updateDoc(path, updates);
  }
  /** Titles an untitled conversation. Resolves false when it already has one, which then stays. */
  async setTitleOnce(userId, conversationId, summary) {
    const path = chatConversationPath(userId, conversationId);
    const titled = await this.compareAndSetDoc(path, { expect: { summary: void 0 }, updates: { summary } });
    this.log.info("Titling ChatConversation", { path, titled });
    return titled;
  }
  /**
   * Append messages and update telemetry counters atomically. Used at the end of
   * each chat turn — the server writes the user message and the assistant reply
   * together so the client's reactive subscription sees a single coherent update.
   *
   * Writes only the fields a turn owns. The title (`summary`) is written separately by the title trigger
   * and can land while a turn is running, so rewriting the whole document from the turn's read would erase it.
   */
  async appendMessages(userId, conversationId, args) {
    const path = chatConversationPath(userId, conversationId);
    const now = (/* @__PURE__ */ new Date()).toISOString();
    const turnFields = {
      messages: [...args.existing.messages, ...args.newMessages],
      tokensIn: args.existing.tokensIn + (args.tokensInDelta ?? 0),
      tokensOut: args.existing.tokensOut + (args.tokensOutDelta ?? 0),
      estimatedCostUsd: args.existing.estimatedCostUsd + (args.costUsdDelta ?? 0),
      lastResponseId: args.lastResponseId ?? args.existing.lastResponseId,
      loadedToolNames: args.loadedToolNames ?? args.existing.loadedToolNames,
      committedDraftIds: args.existing.committedDraftIds,
      cancelledDraftIds: args.existing.cancelledDraftIds,
      updatedAt: now
    };
    this.log.info("Appending messages to ChatConversation", {
      path,
      newCount: args.newMessages.length,
      totalCount: turnFields.messages.length
    });
    await this.adapter.updateDoc(path, turnFields);
  }
};

// src/dao/BaseCompanyDao.ts
import { CompanySchema } from "@rock/types";
var BaseCompanyDao = class extends BaseDao {
  constructor() {
    super("CompanyDao");
  }
  async getCompany(companyId) {
    const path = companyPath(companyId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, CompanySchema, path, this.log) : void 0;
  }
  async setCompany(companyId, data) {
    const path = companyPath(companyId);
    this.log.info("Setting Company", { path });
    await this.adapter.setDoc(path, { ...data, active: true });
  }
  async updateCompany(companyId, updates) {
    const path = companyPath(companyId);
    this.log.info("Updating Company", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async deleteCompany(companyId) {
    this.log.info("Deleting company", { companyId });
    await this.updateCompany(companyId, { active: false });
  }
};

// src/dao/BaseConsiderationDao.ts
import { ConsiderationSchema } from "@rock/types";
var BaseConsiderationDao = class extends BaseDao {
  constructor() {
    super("ConsiderationDao");
  }
  async getConsideration(homeId, considerationId) {
    const path = considerationPath(homeId, considerationId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ConsiderationSchema, path, this.log) : void 0;
  }
  async setConsideration(homeId, considerationId, data) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Setting Consideration", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateConsideration(homeId, considerationId, updates) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Updating Consideration", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * "Never": the suggestion is wrong for this home, so it stops coming back — `ignored`, carrying
   * the decline reason when the chips gave one.
   *
   * `reviewAt` is deliberately LEFT IN PLACE. A row declined from the weekend checklist has to stay
   * on that checklist, ticked, until the weekend is over — `thisWeekReviewsState` decides membership
   * by the date, so clearing it would make the row vanish under the homeowner's thumb and take the
   * "Reconsider" undo with it. Nothing brings a declined suggestion back regardless: every query
   * that would raise it again filters on `pending`.
   *
   * Its counterpart is `deferConsiderationReview` — "Maybe Later" is a date, not a decision.
   *
   * Marks it read too: answering it is having seen it, and an unread flag left on an answered row
   * would keep the Home tab's dot lit with nothing on the dashboard left to clear it.
   */
  async declineConsideration(homeId, considerationId, answer, now, by) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Declining Consideration", { path, answer, by });
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, {
      status: "ignored",
      declineReason: answer.declineReason ?? del,
      reviewedAt: answer.reviewedAt,
      decidedBy: by,
      read: true,
      updatedAt: now
    });
  }
  /**
   * "Maybe Later": the homeowner pushes a suggestion out to a weekend of their choosing. Mostly the
   * same write as `scheduleConsiderationReview` — the date moves — plus the `snoozedAt` stamp that
   * records they moved it rather than us, which is what the activity feed reads and what keeps a row
   * the home review set aside from being pre-checked again.
   *
   * `pending` is written rather than assumed: the same verb is offered as "Check again in…" on an
   * ALREADY-DECLINED suggestion, and there it has to undo the decline — a future `reviewAt` on an
   * `ignored` doc would be picked up by nothing (every query that brings a suggestion back filters
   * on `pending`), so the promise in the toast would never be kept. The decline reason goes with it.
   *
   * Beyond that there is no status to undo and no job to bring it back: the date alone governs when
   * the checklist raises it and when Suggestions counts it again.
   */
  async deferConsiderationReview(homeId, considerationId, reviewAt, answer, now, by) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Deferring Consideration review", { path, reviewAt, by });
    await this.adapter.updateDoc(path, {
      status: "pending",
      declineReason: this.deleteFieldValue(),
      reviewAt,
      reviewedAt: answer.reviewedAt,
      snoozedAt: now,
      decidedBy: by,
      updatedAt: now
    });
  }
  /**
   * "Now", from a pushed-out or ignored suggestion's card: back onto this week's list on `reviewAt`
   * (today). Every answer is taken back with it — `pending` again, no decline reason, and no
   * `snoozedAt`, so the row stops reading as one the homeowner set aside — the way
   * `reopenConsideration` does, but with the date moved too.
   */
  async bringBackConsideration(homeId, considerationId, reviewAt, now) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Bringing back Consideration", { path, reviewAt });
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, {
      status: "pending",
      reviewAt,
      snoozedAt: del,
      declineReason: del,
      reviewedAt: del,
      decidedBy: del,
      updatedAt: now
    });
  }
  /**
   * Schedule a pending consideration to surface on the weekend checklist as a Suggested Reminder on
   * `reviewAt` (a Saturday). Leaves `status` alone — the item stays a pending suggestion; the date only
   * governs when the checklist brings it up and whether Suggestions badges it.
   */
  async scheduleConsiderationReview(homeId, considerationId, reviewAt, now) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Scheduling Consideration review", { path, reviewAt });
    await this.adapter.updateDoc(path, { reviewAt, updatedAt: now });
  }
  /**
   * The homeowner's own read flag, from the list's quick actions. Marking read stamps `lastReadAt` the
   * way opening the suggestion does; marking unread only lowers the flag, so the red dot comes back.
   */
  async setConsiderationRead(homeId, considerationId, read, now) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Setting Consideration read", { path, read });
    await this.adapter.updateDoc(path, read ? { read, lastReadAt: now, updatedAt: now } : { read, updatedAt: now });
  }
  /**
   * Undo a decline from the weekend checklist: back to `pending`, on the SAME weekend — the row is
   * being un-ticked, not sent back to the queue, so `reviewAt` stays put and it remains on this weekend's list,
   * open again. The decline bookkeeping goes with it (a stale `reviewedAt` would read as answered),
   * as does `snoozedAt`, so an un-ticked row isn't still marked as one the homeowner pushed out.
   * The home review reopens a pushed-back row the same way when it goes back on the list: its
   * `snoozedAt` would otherwise keep reading as "set aside" over the checkbox.
   * Removing a field needs the delete sentinel — `{ field: undefined }` is a silent no-op.
   */
  async reopenConsideration(homeId, considerationId, now) {
    const path = considerationPath(homeId, considerationId);
    this.log.info("Reopening Consideration", { path });
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, {
      status: "pending",
      snoozedAt: del,
      declineReason: del,
      reviewedAt: del,
      decidedBy: del,
      updatedAt: now
    });
  }
  /**
   * Accept a suggestion together with the reminders it becomes and whichever first tasks were
   * generated for them, in ONE atomic commit. A reminder stamped `lastGeneratedAt` tells the server
   * its first task already exists — `onHomeTaskSubscriptionCreated` skips it, and the hourly job's
   * pending guard looks for that task — so the stamp must never land without its task, nor the task
   * without the reminder that owns it.
   */
  async acceptConsiderationWithReminders(homeId, considerationId, accept) {
    const path = considerationPath(homeId, considerationId);
    const { updates, subscriptions, firstTasks } = accept;
    this.log.info("Accepting Consideration with reminders", {
      path,
      updates,
      subscriptionIds: subscriptions.map((s) => s.id),
      taskIds: firstTasks.map((t) => t.id)
    });
    await this.commitBatch([
      ...subscriptions.map(
        (s) => ({ kind: "set", path: homeTaskSubscriptionPath(homeId, s.id), data: s })
      ),
      ...firstTasks.map((t) => ({ kind: "set", path: taskPath(homeId, t.id), data: t })),
      { kind: "update", path, updates }
    ]);
  }
};

// src/dao/BaseAppliesToOwnerDao.ts
var BaseAppliesToOwnerDao = class extends BaseDao {
  /**
   * Record what the drafting step produced, stamped with the task version that produced it. A draft
   * replaces the previous one whole, so a stale `issue` never outlives the query it described;
   * `undefined` removes it (nothing is left to review). The approved `appliesTo` is never touched here.
   */
  async saveAppliesToDraft(typeId, { draft, taskVersion }) {
    const path = this.appliesToPath(typeId);
    this.log.info("Saving applies-to draft", { path, draft, taskVersion });
    await this.updateDoc(path, {
      appliesToDraft: draft ?? this.deleteFieldValue(),
      currentAppliesToDraftTaskVersion: taskVersion,
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    });
  }
  /**
   * Make `query` the type's applies-to query. `clearDraft` when the admin approved (or edited) the
   * draft itself, so it stops waiting for review; an unrelated edit leaves a pending draft in place.
   */
  async approveAppliesTo(typeId, { query, approvedBy, clearDraft }) {
    const path = this.appliesToPath(typeId);
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Approving applies-to query", { path, query, approvedBy, clearDraft });
    await this.updateDoc(path, {
      appliesTo: query,
      appliesToApprovedAt: now,
      appliesToApprovedBy: approvedBy,
      ...clearDraft ? { appliesToDraft: this.deleteFieldValue() } : {},
      updatedAt: now
    });
  }
  async dismissAppliesToDraft(typeId) {
    const path = this.appliesToPath(typeId);
    this.log.info("Dismissing applies-to draft", { path });
    await this.updateDoc(path, {
      appliesToDraft: this.deleteFieldValue(),
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    });
  }
  /**
   * Ask for a fresh draft. The drafting trigger fires on any change to the requested version, so this
   * only has to move it; the server's own version constant stays the server's business. Resolves to the
   * `updatedAt` it wrote: while the doc still carries it, nothing (the draft included) has landed since.
   */
  async requestAppliesToDraft(type) {
    const path = this.appliesToPath(type.id);
    const requested = (type.requestedAppliesToDraftTaskVersion ?? 0) + 1;
    const updatedAt = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Requesting an applies-to draft", { path, requested });
    await this.updateDoc(path, { requestedAppliesToDraftTaskVersion: requested, updatedAt });
    return updatedAt;
  }
};

// src/dao/BaseConsiderationTypeDao.ts
import { ConsiderationTypeSchema, titledConsideration } from "@rock/types";
var BaseConsiderationTypeDao = class extends BaseAppliesToOwnerDao {
  constructor() {
    super("ConsiderationTypeDao");
  }
  appliesToPath(typeId) {
    return considerationTypePath(typeId);
  }
  async getConsiderationType(typeId) {
    const path = considerationTypePath(typeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ConsiderationTypeSchema, path, this.log) : void 0;
  }
  /** Names each consideration by its type's current title, reading each type once. */
  async titleConsiderations(considerations) {
    const typeIds = Array.from(new Set(considerations.map((consideration) => consideration.typeId)));
    const types = new Map(
      await Promise.all(
        typeIds.map(async (typeId) => [typeId, await this.getConsiderationType(typeId)])
      )
    );
    return considerations.map(
      (consideration) => titledConsideration(consideration, types.get(consideration.typeId))
    );
  }
  /** Whether the doc exists at all, parseable or not — `getConsiderationType` returns undefined for both. */
  async hasConsiderationType(typeId) {
    const path = considerationTypePath(typeId);
    return !!await this.adapter.getDoc(path);
  }
  async setConsiderationType(typeId, data) {
    const path = considerationTypePath(typeId);
    this.log.info("Setting ConsiderationType", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateConsiderationType(typeId, updates) {
    const path = considerationTypePath(typeId);
    this.log.info("Updating ConsiderationType", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseContactDao.ts
import { ContactSchema } from "@rock/types";
var BaseContactDao = class extends BaseDao {
  constructor() {
    super("ContactDao");
  }
  async getContact(homeId, contactId) {
    const path = contactPath(homeId, contactId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ContactSchema, path, this.log) : void 0;
  }
  async setContact(homeId, contactId, data) {
    const path = contactPath(homeId, contactId);
    this.log.info("Setting Contact", { path });
    await this.adapter.setDoc(path, { ...data, active: true });
  }
  async updateContact(homeId, contactId, updates) {
    const path = contactPath(homeId, contactId);
    this.log.info("Updating Contact", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async deleteContact(homeId, contactId) {
    this.log.info("Deleting contact", { homeId, contactId });
    await this.updateContact(homeId, contactId, { active: false });
  }
  /**
   * Sets or clears the contact's address override. Writing an empty/undefined value removes
   * `addressText`, `address`, and `geo` entirely (uses FieldValue.delete() under the hood so
   * the fields are actually removed, not left as undefined). Writing a non-empty value
   * stores the new `addressText` and clears the derived `address`/`geo` so the enrichContact
   * trigger can repopulate them — avoids a stale map/address showing during the enrichment
   * window.
   */
  async setContactAddressOverride(homeId, contactId, addressText) {
    const path = contactPath(homeId, contactId);
    const del = this.adapter.deleteFieldValue();
    const updates = {
      address: del,
      geo: del,
      addressText: addressText ? addressText : del
    };
    this.log.info("Setting Contact address override", { path, addressText });
    await this.adapter.updateDoc(path, updates);
  }
  async setContactLabel(homeId, contactId, label) {
    const path = contactPath(homeId, contactId);
    const updates = {
      label: label ? label : this.adapter.deleteFieldValue()
    };
    this.log.info("Setting Contact label", { path, label });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseCustomEquipmentTypeDao.ts
import { CustomEquipmentTypeSchema } from "@rock/types";
var BaseCustomEquipmentTypeDao = class extends BaseDao {
  constructor() {
    super("CustomEquipmentTypeDao");
  }
  async getCustomEquipmentType(homeId, typeId) {
    const path = customEquipmentTypePath(homeId, typeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, CustomEquipmentTypeSchema, path, this.log) : void 0;
  }
  async setCustomEquipmentType(homeId, typeId, data) {
    const path = customEquipmentTypePath(homeId, typeId);
    this.log.info("Setting CustomEquipmentType", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateCustomEquipmentType(homeId, typeId, updates) {
    const path = customEquipmentTypePath(homeId, typeId);
    this.log.info("Updating CustomEquipmentType", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseCustomTaskTypeDao.ts
import { CustomTaskTypeSchema } from "@rock/types";
var BaseCustomTaskTypeDao = class extends BaseDao {
  constructor() {
    super("CustomTaskTypeDao");
  }
  async getCustomTaskType(homeId, typeId) {
    const path = customTaskTypePath(homeId, typeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, CustomTaskTypeSchema, path, this.log) : void 0;
  }
  async setCustomTaskType(homeId, typeId, data) {
    const path = customTaskTypePath(homeId, typeId);
    this.log.info("Setting CustomTaskType", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateCustomTaskType(homeId, typeId, updates) {
    const path = customTaskTypePath(homeId, typeId);
    this.log.info("Updating CustomTaskType", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseDeviceDao.ts
import { DeviceSchema } from "@rock/types";
var BaseDeviceDao = class extends BaseDao {
  constructor() {
    super("DeviceDao");
  }
  async getDevice(userId, deviceId) {
    const path = userDevicePath(userId, deviceId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, DeviceSchema, path, this.log) : void 0;
  }
  async setDevice(userId, deviceId, data) {
    const path = userDevicePath(userId, deviceId);
    this.log.info("Setting Device", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateDevice(userId, deviceId, updates) {
    const path = userDevicePath(userId, deviceId);
    this.log.info("Updating Device", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseDomainEventDao.ts
import { DomainEventSchema } from "@rock/types";
var BaseDomainEventDao = class extends BaseDao {
  constructor() {
    super("DomainEventDao");
  }
  async getDomainEvent(eventId) {
    const path = domainEventPath(eventId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, DomainEventSchema, path, this.log) : void 0;
  }
  async setDomainEvent(eventId, data) {
    const path = domainEventPath(eventId);
    this.log.info("Setting DomainEvent", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateDomainEvent(eventId, updates) {
    const path = domainEventPath(eventId);
    this.log.info("Updating DomainEvent", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseEquipmentDao.ts
import { EquipmentSchema } from "@rock/types";
var BaseEquipmentDao = class extends BaseDao {
  constructor() {
    super("EquipmentDao");
  }
  // Image writes are scoped to a single image's map entry (`images.<id>`) plus array transforms
  // on `imageOrder`, so concurrent writers (upload writeback, rehost, reorder) compose instead
  // of clobbering each other. Never write the whole `images` field — see rock-types
  // imageCollection.ts for the rationale.
  /**
   * Sets or clears (undefined → root) the folder this equipment lives in. A dedicated method
   * because clearing via `updateEquipment({ folderId: undefined })` would be a silent no-op —
   * removing a field needs deleteFieldValue.
   */
  async setEquipmentFolder(homeId, equipmentId, folderId) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Setting Equipment folder", { path, folderId });
    await this.adapter.updateDoc(path, { folderId: folderId ?? this.adapter.deleteFieldValue() });
  }
  /**
   * Adds one image (or fully replaces the entry with the same id) and appends its id to the
   * display order (no-op when already present).
   */
  async putImage(homeId, equipmentId, image) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Putting Equipment image", { path, imageId: image.id });
    await this.adapter.updateDoc(path, {
      [`images.${image.id}`]: image,
      imageOrder: this.adapter.arrayUnionValue(image.id)
    });
  }
  /** Removes one image from the map and its id from the display order. */
  async removeImage(homeId, equipmentId, imageId) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Removing Equipment image", { path, imageId });
    await this.adapter.updateDoc(path, {
      [`images.${imageId}`]: this.adapter.deleteFieldValue(),
      imageOrder: this.adapter.arrayRemoveValue(imageId)
    });
  }
  /**
   * Fully replaces one image's map entry WITHOUT touching `imageOrder`. For long-running
   * server-side URL swaps (rehost): if the image is deleted mid-operation, this re-creates a
   * complete, valid entry that stays orphaned from the order (invisible to readers, and never
   * pointing a resurrected image at deleted Storage blobs) — never a partial entry that would
   * poison the doc parse the way a per-field dot-path write racing a delete would.
   */
  async putImageEntry(homeId, equipmentId, image) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Putting Equipment image entry", { path, imageId: image.id });
    await this.adapter.updateDoc(path, { [`images.${image.id}`]: image });
  }
  /**
   * Patches individual fields on one image (e.g. `rotation`, `categories`). Keys explicitly set
   * to `undefined` are cleared; absent keys are untouched. Prefer this for quick user edits —
   * unlike a whole-entry write, it can never revert a concurrent writeback's URL fields on the
   * same image. For seconds-long operations, use {@link putImageEntry} instead (a delete racing
   * a dot-path write would resurrect a partial, parse-poisoning entry).
   */
  async updateImageFields(homeId, equipmentId, imageId, fields) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Updating Equipment image fields", { path, imageId, fields });
    await this.adapter.updateDoc(path, this.toFieldPaths(fields, `images.${imageId}`));
  }
  /**
   * Rewrites the display order (first = primary) without touching the images map. Last writer
   * wins on ordering alone — an acceptable race, unlike losing image data.
   */
  async setImageOrder(homeId, equipmentId, imageOrder) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Setting Equipment image order", { path, imageOrder });
    await this.adapter.updateDoc(path, { imageOrder });
  }
  /**
   * Replaces `oldImageId` with `image` in a single write: swaps the map entries and applies the
   * caller-computed order (typically the old order with the new id in the old one's position).
   */
  async replaceImage(homeId, equipmentId, oldImageId, image, imageOrder) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Replacing Equipment image", { path, oldImageId, imageId: image.id });
    await this.adapter.updateDoc(path, {
      [`images.${oldImageId}`]: this.adapter.deleteFieldValue(),
      [`images.${image.id}`]: image,
      imageOrder
    });
  }
  async getEquipment(homeId, equipmentId) {
    const path = equipmentPath(homeId, equipmentId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, EquipmentSchema, path, this.log) : void 0;
  }
  async setEquipment(homeId, equipmentId, data) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Setting Equipment", { path });
    await this.adapter.setDoc(path, data);
  }
  /**
   * The permanent removal the owner asks for from the archive. The document stays readable so a
   * completed task can still name what it covered and an archived reminder can still say what it was
   * waiting on; `deleted` is what takes it out of every list, for good.
   */
  async deleteEquipmentForever(homeId, equipmentId, by) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Deleting Equipment for good", { path, by });
    await this.adapter.updateDoc(path, {
      active: false,
      status: "deleted",
      deletedAt: (/* @__PURE__ */ new Date()).toISOString(),
      deletedBy: by
    });
  }
  /** A restore takes the archive's stamps with it. */
  async clearArchiveStamps(homeId, equipmentId) {
    const path = equipmentPath(homeId, equipmentId);
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, { archivedAt: del, archivedBy: del });
  }
  async updateEquipment(homeId, equipmentId, updates) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Updating Equipment", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /** The brand of the product the unit resolved to, as the catalog names it; none clears it. */
  async setDetailsBrand(homeId, equipmentId, brand) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Setting Equipment product brand", { path, brand });
    await this.adapter.updateDoc(path, { "details.brand": brand ?? this.adapter.deleteFieldValue() });
  }
  async updateQuantity(homeId, equipmentId, quantity) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Updating equipment quantity", { path, quantity });
    await this.adapter.updateDoc(path, { "fields.quantity": quantity, updatedAt: (/* @__PURE__ */ new Date()).toISOString() });
  }
  /**
   * Update the nickname for an Equipment item. Empty/whitespace nickname
   * deletes the field (Firestore drops `undefined`, so clearing requires the
   * adapter's deleteFieldValue sentinel).
   */
  async updateNickname(homeId, equipmentId, nickname) {
    const trimmed = nickname?.trim() ?? "";
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Updating Equipment nickname", { path, nickname: trimmed });
    await this.adapter.updateDoc(path, {
      nickname: trimmed ? trimmed : this.adapter.deleteFieldValue()
    });
  }
  /**
   * Clears a persisted serial-year confirmation (Firestore drops `undefined`,
   * so clearing requires the adapter's deleteFieldValue sentinel).
   */
  async clearSerialConfirmation(homeId, equipmentId) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Clearing Equipment serial confirmation", { path });
    await this.adapter.updateDoc(path, {
      serialConfirmation: this.adapter.deleteFieldValue()
    });
  }
  /**
   * Clears the catalog-resolved model snapshot (`details`, `sources`,
   * `refreshId`). Called after a model number change so a stale model lookup
   * doesn't outlive the new value.
   */
  /**
   * Drop what a model lookup found while the lookup itself stands: the refresh that ended asking the owner
   * a question keeps its `refreshId`, since the app reads the question through it.
   */
  async clearResolvedDetails(homeId, equipmentId) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Clearing Equipment resolved details", { path });
    await this.adapter.updateDoc(path, {
      details: this.adapter.deleteFieldValue(),
      sources: this.adapter.deleteFieldValue()
    });
  }
  /**
   * Move the unit to another catalog model: its three identity fields and the new model's brand, as the
   * catalog names it. What the research found stays until the next refresh re-copies it.
   */
  async repointModel(homeId, equipmentId, identity) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Repointing Equipment model", { path, modelId: identity.modelId });
    await this.adapter.updateDoc(path, {
      "details.modelId": identity.modelId,
      "details.modelDisplay": identity.modelDisplay,
      "details.modelCanonical": identity.modelCanonical,
      "details.brand": identity.brand ?? this.adapter.deleteFieldValue()
    });
  }
  async clearModelDetails(homeId, equipmentId) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Clearing Equipment Model Details", { path });
    await this.adapter.updateDoc(path, {
      details: this.adapter.deleteFieldValue(),
      sources: this.adapter.deleteFieldValue(),
      refreshId: this.adapter.deleteFieldValue()
    });
  }
  /**
   * Sets or clears the `refreshId` on an Equipment item. Pass `null` to
   * clear (Firestore drops `undefined`, so clearing needs the adapter's
   * deleteFieldValue sentinel).
   */
  async updateRefreshId(homeId, equipmentId, refreshId) {
    const path = equipmentPath(homeId, equipmentId);
    this.log.info("Updating Equipment refreshId", { path, refreshId });
    await this.adapter.updateDoc(path, {
      refreshId: refreshId ? refreshId : this.adapter.deleteFieldValue()
    });
  }
};

// src/dao/BaseEquipmentImageSearchRequestDao.ts
import { EquipmentImageSearchRequestSchema } from "@rock/types";
var BaseEquipmentImageSearchRequestDao = class extends BaseDao {
  constructor() {
    super("EquipmentImageSearchRequestDao");
  }
  async getEquipmentImageSearchRequest(homeId, requestId) {
    const path = equipmentImageSearchRequestPath(homeId, requestId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, EquipmentImageSearchRequestSchema, path, this.log) : void 0;
  }
  async setEquipmentImageSearchRequest(homeId, requestId, data) {
    const path = equipmentImageSearchRequestPath(homeId, requestId);
    this.log.info("Setting EquipmentImageSearchRequest", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateEquipmentImageSearchRequest(homeId, requestId, updates) {
    const path = equipmentImageSearchRequestPath(homeId, requestId);
    this.log.info("Updating EquipmentImageSearchRequest", {
      path,
      status: updates.status,
      imageCount: updates.images?.length
    });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseEquipmentRefreshDao.ts
import { TaskRefreshSchema } from "@rock/types";
var BaseEquipmentRefreshDao = class extends BaseDao {
  constructor() {
    super("EquipmentRefreshDao");
  }
  async getEquipmentRefresh(homeId, equipmentId, refreshId) {
    const path = equipmentRefreshPath(homeId, equipmentId, refreshId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, TaskRefreshSchema, path, this.log) : void 0;
  }
  async setEquipmentRefresh(homeId, equipmentId, refreshId, data) {
    const path = equipmentRefreshPath(homeId, equipmentId, refreshId);
    this.log.info("Setting EquipmentRefresh", { path });
    await this.adapter.setDoc(path, data);
  }
  /**
   * Atomically move a refresh forward only if it still looks like `expect` — see
   * `DbAdapter.compareAndSetDoc`. Resolves false when someone else got there first, which is a
   * normal outcome for a trigger that can see the same work twice, not an error.
   */
  async claimEquipmentRefresh(homeId, equipmentId, refreshId, args) {
    const path = equipmentRefreshPath(homeId, equipmentId, refreshId);
    const claimed = await this.compareAndSetDoc(path, args);
    this.log.info(claimed ? "Claimed EquipmentRefresh" : "EquipmentRefresh already claimed", { path, ...args });
    return claimed;
  }
  async updateEquipmentRefresh(homeId, equipmentId, refreshId, updates) {
    const path = equipmentRefreshPath(homeId, equipmentId, refreshId);
    this.log.info("Updating EquipmentRefresh", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseEquipmentTestLibraryDao.ts
import { EquipmentTestLibraryEntrySchema } from "@rock/types";
var BaseEquipmentTestLibraryDao = class extends BaseDao {
  constructor() {
    super("EquipmentTestLibraryDao");
  }
  async getEntry(entryId) {
    const path = equipmentTestLibraryEntryPath(entryId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, EquipmentTestLibraryEntrySchema, path, this.log) : void 0;
  }
  async setEntry(entryId, data) {
    const path = equipmentTestLibraryEntryPath(entryId);
    this.log.info("Setting Equipment Test Library entry", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateEntry(entryId, updates) {
    const path = equipmentTestLibraryEntryPath(entryId);
    this.log.info("Updating Equipment Test Library entry", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async deleteEntry(entryId) {
    const path = equipmentTestLibraryEntryPath(entryId);
    this.log.info("Deleting Equipment Test Library entry", { path });
    await this.adapter.deleteDoc(path);
  }
};

// src/dao/BaseEquipmentTypeCandidateDao.ts
import { EquipmentTypeCandidateSchema } from "@rock/types";
var BaseEquipmentTypeCandidateDao = class extends BaseDao {
  constructor() {
    super("EquipmentTypeCandidateDao");
  }
  async getEquipmentTypeCandidate(candidateId) {
    const path = equipmentTypeCandidatePath(candidateId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, EquipmentTypeCandidateSchema, path, this.log) : void 0;
  }
  async setEquipmentTypeCandidate(candidateId, data) {
    const path = equipmentTypeCandidatePath(candidateId);
    this.log.info("Setting EquipmentTypeCandidate", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateEquipmentTypeCandidate(candidateId, updates) {
    const path = equipmentTypeCandidatePath(candidateId);
    this.log.info("Updating EquipmentTypeCandidate", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Point the candidate at the catalog type its promotion is headed for, or unlink it (`undefined`)
   * when that type is gone or was the wrong call. A dedicated method because clearing needs the
   * adapter's deleteFieldValue sentinel — `{ promotionTypeId: undefined }` is a silent no-op.
   */
  async setPromotionTypeId(candidateId, typeId) {
    const path = equipmentTypeCandidatePath(candidateId);
    this.log.info("Setting EquipmentTypeCandidate promotionTypeId", { path, typeId });
    await this.adapter.updateDoc(path, { promotionTypeId: typeId ?? this.adapter.deleteFieldValue() });
  }
};

// src/dao/BaseEquipmentTypeDao.ts
import { EquipmentTypeSchema, isCustomId } from "@rock/types";
var EQUIPMENT_TYPE_PRESERVED_ON_PUBLISH = [
  "order",
  "group",
  "retiredAt",
  "replacedBy"
];
var BaseEquipmentTypeDao = class extends BaseDao {
  drafts;
  constructor() {
    super("EquipmentTypeDao");
    this.drafts = new DraftLayer({
      adapter: this.adapter,
      log: this.log,
      schema: EquipmentTypeSchema,
      diffIgnoreFields: [...EQUIPMENT_TYPE_PRESERVED_ON_PUBLISH],
      mergeOnPublish: ({ retiredAt: _retiredAt, replacedBy: _replacedBy, ...draft }, live) => ({
        ...draft,
        order: live?.order ?? draft.order,
        group: live?.group ?? draft.group,
        images: draft.images && draft.images.length > 0 ? draft.images : live?.images ?? draft.images,
        ...live?.retiredAt ? { retiredAt: live.retiredAt } : {},
        ...live?.replacedBy ? { replacedBy: live.replacedBy } : {}
      })
    });
  }
  async getEquipmentType(typeId) {
    const path = equipmentTypePath(typeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, EquipmentTypeSchema, path, this.log) : void 0;
  }
  /**
   * Routes a typeId to either the shared catalog or the home-scoped custom
   * collection by the `c:` prefix. The custom branch lives at a different
   * Firestore path than the catalog, so the caller passes in the matching
   * DAO rather than this class owning a reference to it.
   */
  async resolveTypeById(typeId, homeId, customDao) {
    if (isCustomId(typeId)) {
      return customDao.getCustomEquipmentType(homeId, typeId);
    }
    return this.getEquipmentType(typeId);
  }
  async setEquipmentType(typeId, data) {
    const path = equipmentTypePath(typeId);
    this.log.info("Setting EquipmentType", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateEquipmentType(typeId, updates) {
    const path = equipmentTypePath(typeId);
    this.log.info("Updating EquipmentType", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /** Retire straight on live; `replacedBy` names the type a retire moved this one's equipment onto. */
  async retireEquipmentType(typeId, opts = {}) {
    const path = equipmentTypePath(typeId);
    const updates = {
      retiredAt: (/* @__PURE__ */ new Date()).toISOString(),
      ...opts.replacedBy && { replacedBy: opts.replacedBy }
    };
    this.log.info("Retiring EquipmentType", { path, ...updates });
    await this.adapter.updateDoc(path, updates);
  }
  /** Back into the catalog. Anything a retire moved onto `replacedBy` stays there. */
  async restoreEquipmentType(typeId) {
    const path = equipmentTypePath(typeId);
    this.log.info("Restoring EquipmentType", { path });
    await this.adapter.updateDoc(path, this.toFieldPaths({ retiredAt: void 0, replacedBy: void 0 }));
  }
  // --- Draft/publish (admin) ---
  // The app reads the live path unchanged; admin edits stage to the doc's slot in the `_draft/db`
  // mirror. Internal devices read the draft directly in preview mode (live-preview WIP), and Publish
  // promotes draft→live (firing enrichment triggers once) and deletes the mirror doc. See DraftLayer.
  // (Guides use a separate frozen-preview flow through the same mirror.)
  getEquipmentTypeDraft(typeId) {
    return this.drafts.getDraft(equipmentTypePath(typeId));
  }
  setEquipmentTypeDraft(typeId, data) {
    return this.drafts.setDraft(equipmentTypePath(typeId), data);
  }
  discardEquipmentTypeDraft(typeId) {
    return this.drafts.discardDraft(equipmentTypePath(typeId));
  }
  /** Seeds a draft from the live doc if none exists, so the admin edits a full working copy. */
  seedEquipmentTypeDraft(typeId) {
    return this.drafts.seedDraftFromLive(equipmentTypePath(typeId));
  }
  /** Promotes the draft to live (fires enrichment triggers once). Throws if there is no draft. */
  publishEquipmentType(typeId) {
    return this.drafts.publish(equipmentTypePath(typeId));
  }
  equipmentTypeDraftStatus(typeId) {
    return this.drafts.status(equipmentTypePath(typeId));
  }
};

// src/dao/BaseEquipmentTypeFamilyDao.ts
import { EquipmentTypeFamilySchema } from "@rock/types";
var BaseEquipmentTypeFamilyDao = class extends BaseDao {
  constructor() {
    super("EquipmentTypeFamilyDao");
  }
  async getEquipmentTypeFamily(familyId) {
    const path = equipmentTypeFamilyPath(familyId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, EquipmentTypeFamilySchema, path, this.log) : void 0;
  }
  async setEquipmentTypeFamily(family) {
    const path = equipmentTypeFamilyPath(family.id);
    this.log.info("Setting EquipmentTypeFamily", { path, typeIds: family.typeIds });
    await this.commitInBatches([{ kind: "set", path, data: family }]);
  }
  async deleteEquipmentTypeFamily(familyId) {
    const path = equipmentTypeFamilyPath(familyId);
    this.log.info("Deleting EquipmentTypeFamily", { path });
    await this.commitInBatches([{ kind: "delete", path }]);
  }
};

// src/dao/BaseEquipmentTypeRefreshDao.ts
import { TaskRefreshSchema as TaskRefreshSchema2 } from "@rock/types";
var BaseEquipmentTypeRefreshDao = class extends BaseDao {
  constructor() {
    super("EquipmentTypeRefreshDao");
  }
  async getEquipmentTypeRefresh(typeId, refreshId) {
    const path = equipmentTypeRefreshPath(typeId, refreshId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, TaskRefreshSchema2, path, this.log) : void 0;
  }
  async setEquipmentTypeRefresh(typeId, refreshId, data) {
    const path = equipmentTypeRefreshPath(typeId, refreshId);
    this.log.info("Setting EquipmentTypeRefresh", { path });
    await this.adapter.setDoc(path, data);
  }
  /** Atomic claim — see `BaseEquipmentRefreshDao.claimEquipmentRefresh`. */
  async claimEquipmentTypeRefresh(typeId, refreshId, args) {
    const path = equipmentTypeRefreshPath(typeId, refreshId);
    const claimed = await this.compareAndSetDoc(path, args);
    this.log.info(claimed ? "Claimed EquipmentTypeRefresh" : "EquipmentTypeRefresh already claimed", {
      path,
      ...args
    });
    return claimed;
  }
  async updateEquipmentTypeRefresh(typeId, refreshId, updates) {
    const path = equipmentTypeRefreshPath(typeId, refreshId);
    this.log.info("Updating EquipmentTypeRefresh", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseFeedbackSubmissionDao.ts
import { FeedbackSubmissionSchema } from "@rock/types";
var BaseFeedbackSubmissionDao = class extends BaseDao {
  constructor() {
    super("FeedbackSubmissionDao");
  }
  async getFeedbackSubmission(feedbackId) {
    const path = feedbackEntryPath(feedbackId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, FeedbackSubmissionSchema, path, this.log) : void 0;
  }
  async setFeedbackSubmission(feedbackId, data) {
    const path = feedbackEntryPath(feedbackId);
    this.log.info("Setting FeedbackSubmission", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateFeedbackSubmission(feedbackId, updates) {
    const path = feedbackEntryPath(feedbackId);
    this.log.info("Updating FeedbackSubmission", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseFolderDao.ts
import { FolderSchema } from "@rock/types";
var BaseFolderDao = class extends BaseDao {
  constructor() {
    super("FolderDao");
  }
  async getFolder(homeId, folderId) {
    const path = folderPath(homeId, folderId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, FolderSchema, path, this.log) : void 0;
  }
  async setFolder(homeId, folderId, data) {
    const path = folderPath(homeId, folderId);
    this.log.info("Setting Folder", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateFolder(homeId, folderId, updates) {
    const path = folderPath(homeId, folderId);
    this.log.info("Updating Folder", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Sets or clears the folder's icon. A dedicated method because `updateFolder(..., { icon:
   * undefined })` would be a silent Firestore no-op — clearing a field needs deleteFieldValue.
   */
  async updateFolderIcon(homeId, folderId, icon) {
    const path = folderPath(homeId, folderId);
    this.log.info("Updating Folder icon", { path, icon });
    await this.adapter.updateDoc(path, { icon: icon ?? this.deleteFieldValue() });
  }
  /** Records a system-guide visit against this folder instance (feeds "Revisit Guided Setup"). */
  async appendGuideVisit(homeId, folderId, guideVisitId) {
    const path = folderPath(homeId, folderId);
    this.log.info("Appending Folder guide visit", { path, guideVisitId });
    await this.adapter.updateDoc(path, { guideVisitIds: this.arrayUnionValue(guideVisitId) });
  }
  /**
   * Archives the folder alone and never cascades: anything still pointing here falls back to root at
   * render time (the dangling-FK rule). The app's folder archive (`useArchiveFolder`) archives the
   * contents first, so that fallback is for legacy rows, not for a fresh archive.
   */
  async deactivateFolder(homeId, folderId, by) {
    const path = folderPath(homeId, folderId);
    this.log.info("Deactivating Folder", { path, by });
    await this.adapter.updateDoc(path, {
      active: false,
      status: "archived",
      archivedAt: (/* @__PURE__ */ new Date()).toISOString(),
      archivedBy: by
    });
  }
  /**
   * Puts an archived folder back. Its contents are restored separately, one write each, so the caller
   * decides what comes with it; equipment still pointing here that stays archived simply doesn't show.
   *
   * A folder removed for good stays removed. The owner asked for that from the archive, and the same
   * guard sits on the equipment side (`update-equipment`), so neither half can be walked back.
   */
  async restoreFolder(homeId, folderId) {
    const folder = await this.getFolder(homeId, folderId);
    if (folder?.status === "deleted") {
      this.log.warn("Refusing to restore a folder that was removed for good", { homeId, folderId });
      return;
    }
    const path = folderPath(homeId, folderId);
    this.log.info("Restoring Folder", { path });
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, { active: true, status: "active", archivedAt: del, archivedBy: del });
  }
  /** See `BaseEquipmentDao.deleteEquipmentForever`: out of every list, still readable. */
  async deleteFolderForever(homeId, folderId, by) {
    const path = folderPath(homeId, folderId);
    this.log.info("Deleting Folder for good", { path, by });
    await this.adapter.updateDoc(path, {
      active: false,
      status: "deleted",
      deletedAt: (/* @__PURE__ */ new Date()).toISOString(),
      deletedBy: by
    });
  }
};

// src/dao/BaseGuideDao.ts
import { GuideSchema, GuideVisitSchema } from "@rock/types";
var BaseGuideDao = class extends BaseDao {
  constructor() {
    super("GuideDao");
  }
  async getGuide(context) {
    const path = guidePath(context);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, GuideSchema, path, this.log) : void 0;
  }
  async setGuide(context, data) {
    const path = guidePath(context);
    this.log.info("Setting Guide", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateGuide(context, updates) {
    const path = guidePath(context);
    this.log.info("Updating Guide", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  // --- Staged preview (admin): an internal-only converted guide internal devices read before it's
  // live. A staged preview is just the guide doc written at its canonical location inside the
  // `_draft/db` mirror (admin-only rules; stamped `_draft: true`), so publish is a copy to the
  // canonical path and no bespoke preview collection exists.
  async getGuidePreview(context) {
    const path = toDraftPath(guidePath(context));
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, GuideSchema, path, this.log) : void 0;
  }
  async setGuidePreview(context, data) {
    const path = toDraftPath(guidePath(context));
    this.log.info("Setting Guide preview", { path });
    await this.adapter.setDoc(path, stampDraft(data));
  }
  /**
   * Promotes the staged preview to live: strips the `_draft` flag, writes the canonical doc, and
   * deletes the mirror doc (the mirror holds only work in flight). Throws if nothing is staged —
   * callers gate on `getGuidePreview` first when they want a friendlier failure.
   */
  async publishGuidePreview(context) {
    const preview = await this.getGuidePreview(context);
    if (!preview) throw new Error(`No staged guide preview to publish at ${toDraftPath(guidePath(context))}`);
    const published = stripDraft(preview);
    await this.setGuide(context, published);
    await this.adapter.deleteDoc(toDraftPath(guidePath(context)));
    return published;
  }
  async getGuideVisit(guideVisitId) {
    const path = guideVisitPath(guideVisitId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, GuideVisitSchema, path, this.log) : void 0;
  }
};

// src/dao/BaseGuideHelpCacheDao.ts
import { GuideHelpCacheSchema } from "@rock/types";
var BaseGuideHelpCacheDao = class extends BaseDao {
  constructor() {
    super("GuideHelpCacheDao");
  }
  async getGuideHelpCache(key) {
    const path = guideHelpCacheEntryPath(key);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, GuideHelpCacheSchema, path, this.log) : void 0;
  }
  async setGuideHelpCache(key, data) {
    const path = guideHelpCacheEntryPath(key);
    this.log.info("Setting GuideHelpCache", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateGuideHelpCache(key, updates) {
    const path = guideHelpCacheEntryPath(key);
    this.log.info("Updating GuideHelpCache", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseGuideHelpRequestDao.ts
import { GuideHelpRequestSchema } from "@rock/types";
var BaseGuideHelpRequestDao = class extends BaseDao {
  constructor() {
    super("GuideHelpRequestDao");
  }
  async getGuideHelpRequest(homeId, helpId) {
    const path = guideHelpRequestPath(homeId, helpId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, GuideHelpRequestSchema, path, this.log) : void 0;
  }
  async setGuideHelpRequest(homeId, helpId, data) {
    const path = guideHelpRequestPath(homeId, helpId);
    this.log.info("Setting GuideHelpRequest", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateGuideHelpRequest(homeId, helpId, updates) {
    const path = guideHelpRequestPath(homeId, helpId);
    this.log.info("Updating GuideHelpRequest", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseGuideStarterDao.ts
import { GuideStarterSchema } from "@rock/types";
import { isTransientReadError } from "@rock/util";
var BaseGuideStarterDao = class extends BaseDao {
  constructor() {
    super("GuideStarterDao");
  }
  async getGuideStarter(homeId, starterId) {
    const path = guideStarterPath(homeId, starterId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, GuideStarterSchema, path, this.log) : void 0;
  }
  async setGuideStarter(homeId, starterId, data) {
    const path = guideStarterPath(homeId, starterId);
    this.log.info("Setting GuideStarter", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateGuideStarter(homeId, starterId, updates) {
    const path = guideStarterPath(homeId, starterId);
    this.log.info("Updating GuideStarter", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Idempotent upsert for the deterministic starter ids. A missing starter is created as given
   * (a staged-equipment type's starter is legitimately born `done`). An existing starter gets
   * ONLY its descriptive fields merge-written — progress (`status`, `completedAt`,
   * `guideVisitIds`, `createdAt`) is never touched, so a space-guide re-run can't reopen a done
   * starter (no done→pending transition exists; redo is "Revisit Guided Setup") and a
   * concurrent `completeGuideStarter` can't be clobbered by this read-then-write.
   */
  async ensureGuideStarter(starter) {
    let existing;
    try {
      existing = await this.getGuideStarter(starter.homeId, starter.id);
    } catch (err) {
      if (!isTransientReadError(err)) throw err;
      this.log.warn(`Starter read unreachable, ensuring via merge: ${starter.id}`, { err });
      return this.mergeStarterBlind(starter);
    }
    if (!existing || existing.kind !== starter.kind) {
      const created = { ...starter, createdAt: starter.createdAt ?? (/* @__PURE__ */ new Date()).toISOString() };
      await this.setGuideStarter(starter.homeId, starter.id, created);
      return created;
    }
    const path = guideStarterPath(starter.homeId, starter.id);
    if (existing.kind === "room" && starter.kind === "room") {
      const descriptive = {
        spaceId: starter.spaceId,
        roomId: starter.roomId,
        // A re-run refreshes a stale name stamp, but an ensure built WITHOUT one (room
        // unreadable offline) must not wipe the existing fallback.
        ...starter.roomName ? { roomName: starter.roomName } : {}
      };
      this.log.info("Refreshing GuideStarter", { path, descriptive });
      await this.adapter.setDoc(path, descriptive, { merge: true });
      return { ...existing, ...descriptive };
    }
    if (existing.kind === "equipment-type" && starter.kind === "equipment-type") {
      const descriptive = { spaceId: starter.spaceId, typeId: starter.typeId };
      this.log.info("Refreshing GuideStarter", { path, descriptive });
      await this.adapter.setDoc(path, descriptive, { merge: true });
      return { ...existing, ...descriptive };
    }
    return existing;
  }
  /** The degraded-read fallback for {@link ensureGuideStarter} — merge-write, fields survive. */
  async mergeStarterBlind(starter) {
    const merged = { ...starter, createdAt: starter.createdAt ?? (/* @__PURE__ */ new Date()).toISOString() };
    const path = guideStarterPath(starter.homeId, starter.id);
    this.log.info("Merging GuideStarter (degraded read)", { path });
    await this.adapter.setDoc(path, merged, { merge: true });
    return merged;
  }
  /**
   * Removes a starter doc outright. Two callers: id migrations (e.g. a custom type promoted
   * onto a catalog type re-keys its starter) and "Skip {Room}" on an empty room visit — skip
   * means "I didn't mean to select this room", so the row disappears rather than reading as
   * "visited, nothing there". TYPE-starter dismissal stays completion, never deletion: a
   * space-guide re-run recreates missing type starters pending, but never reopens done ones.
   * A deleted ROOM starter only comes back if a re-run finishes with the room still checked —
   * which is a re-confirmation, not a resurrection.
   */
  async deleteGuideStarter(homeId, starterId) {
    const path = guideStarterPath(homeId, starterId);
    this.log.info("Deleting GuideStarter", { path });
    await this.adapter.deleteDoc(path);
  }
  /**
   * Read-free completion UPSERT: one queueable merge-write of the starter's descriptive
   * identity plus `status: 'done'`/`completedAt`. For completion surfaces that must work
   * offline (the room-visit "Done") — an existence read would hard-fail on an offline cache
   * miss, and a missing doc is a legal state there (quick-adds can surface rooms no guide
   * ever started). Merge semantics leave any existing `guideVisitIds` untouched.
   *
   * Clears `dismissedAt` like {@link completeGuideStarter}: EVERY done-by-completion write drops
   * the stamp, so only `dismissGuideStarter` can set it. Without that this path — the one a
   * system-scope equipment guide reaches, since it records its visit on the folder and so passes
   * no visit id to `completeGuideStarter` — would leave a dismissed starter uncredited forever.
   */
  async upsertDoneGuideStarter(starter) {
    const path = guideStarterPath(starter.homeId, starter.id);
    this.log.info("Upserting done GuideStarter", { path });
    await this.adapter.setDoc(
      path,
      {
        ...starter,
        status: "done",
        completedAt: (/* @__PURE__ */ new Date()).toISOString(),
        dismissedAt: this.deleteFieldValue()
      },
      { merge: true }
    );
  }
  /**
   * Marks a starter done, optionally recording the guide visit that completed it. The starter
   * must exist — callers complete starters they just read (an ensured launch anchor, or a
   * `planStartersOnEquipmentCreated` match), never a blind id. Idempotent — re-completing
   * (e.g. "Revisit Guided Setup" finishing again) appends the visit and refreshes
   * `completedAt` to the latest completion.
   *
   * Clears any `dismissedAt`: actually setting the thing up outranks having once opted out of
   * it, so a dismissed-then-completed starter scores as the accomplishment it now is.
   */
  async completeGuideStarter(homeId, starterId, guideVisitId) {
    const path = guideStarterPath(homeId, starterId);
    this.log.info("Completing GuideStarter", { path, guideVisitId });
    await this.adapter.updateDoc(path, {
      status: "done",
      completedAt: (/* @__PURE__ */ new Date()).toISOString(),
      dismissedAt: this.deleteFieldValue(),
      ...guideVisitId ? { guideVisitIds: this.arrayUnionValue(guideVisitId) } : {}
    });
  }
  /**
   * Dismisses a starter — "I'm not setting this one up." Done (so a space-guide re-run can't
   * resurrect the row: `ensureGuideStarter` recreates MISSING starters pending but never reopens
   * done ones, which is why this can't be a delete) and stamped `dismissedAt`, which keeps it out
   * of the progress score and off the setup checklist rather than crediting it with a checkmark.
   *
   * No `completedAt` — nothing was completed, and the two stamps would contradict each other
   * (cf. `BaseLessonDao.dismissLesson`). Like {@link completeGuideStarter} the starter must
   * already exist: the caller dismisses one it can see on screen, never a blind id.
   */
  async dismissGuideStarter(homeId, starterId) {
    const path = guideStarterPath(homeId, starterId);
    this.log.info("Dismissing GuideStarter", { path });
    await this.adapter.updateDoc(path, { status: "done", dismissedAt: (/* @__PURE__ */ new Date()).toISOString() });
  }
  /** A dismissal on behalf of a retire of the starter's type, stamped so a restore can find it. */
  async dismissForRetiredType(homeId, starterId) {
    const path = guideStarterPath(homeId, starterId);
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Dismissing GuideStarter for a retired type", { path });
    await this.adapter.updateDoc(path, { status: "done", dismissedAt: now, typeRetiredAt: now });
  }
  /** Undoes {@link dismissForRetiredType} when its type is restored: pending again, both stamps cleared. */
  async reopenRetiredTypeStarter(homeId, starterId) {
    const path = guideStarterPath(homeId, starterId);
    this.log.info("Reopening GuideStarter of a restored type", { path });
    await this.adapter.updateDoc(path, {
      status: "pending",
      dismissedAt: this.deleteFieldValue(),
      typeRetiredAt: this.deleteFieldValue()
    });
  }
};

// src/dao/BaseHomeDao.ts
import { HomeSchema, HomeSpaceSchema } from "@rock/types";
var BaseHomeDao = class extends BaseDao {
  constructor() {
    super("HomeDao");
  }
  async getHome(homeId) {
    const path = homePath(homeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeSchema, path, this.log) : void 0;
  }
  async setHome(homeId, data) {
    const path = homePath(homeId);
    this.log.info("Setting Home", { path, data });
    await this.adapter.setDoc(path, { ...data, memberIds: data.memberIds ?? [data.owner], active: true });
  }
  /**
   * The create-only path: stamps `createdAt` and, while online, resolves once the document is ON
   * THE SERVER rather than merely queued. Everything under a home is read through the rules'
   * `isHomeAccessible()`, which `get()`s the home doc — a subcollection query sent before that doc
   * has landed is denied, and a first read has no retry. `setHome` stays the plain write for a
   * caller with nothing to sequence behind it (the seeders), on every surface's default durability.
   */
  async createHome(home, now) {
    const path = homePath(home.id);
    this.log.info("Creating Home", { path, home });
    await this.adapter.setDoc(
      path,
      { ...home, memberIds: [home.owner], active: true, createdAt: now },
      { awaitServerAck: true }
    );
  }
  /** Lists `userId` among the home's members; an array transform, so a concurrent change to the list is kept. */
  async addHomeMemberId(homeId, userId) {
    const path = homePath(homeId);
    this.log.info("Listing a home member", { path, userId });
    await this.adapter.updateDoc(path, { memberIds: this.arrayUnionValue(userId) });
  }
  /** Drops `userId` from the home's members, by the same array transform. */
  async removeHomeMemberId(homeId, userId) {
    const path = homePath(homeId);
    this.log.info("Unlisting a home member", { path, userId });
    await this.adapter.updateDoc(path, { memberIds: this.arrayRemoveValue(userId) });
  }
  /** Hands the home to another of its members; the membership roles are written beside it by the caller. */
  async setHomeOwner(homeId, userId) {
    const path = homePath(homeId);
    this.log.info("Setting the home owner", { path, userId });
    await this.adapter.updateDoc(path, { owner: userId });
  }
  async updateHome(homeId, updates) {
    const path = homePath(homeId);
    this.log.info("Updating Home", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Replaces ONE space's `spaceSummary` entry, leaving the rest of the map — and the rest of the
   * home — untouched. A dot-path write, so two spaces finishing at once can't drop each other's
   * entry, and neither can revert a lifecycle field the server just stamped (`planReadyAt`,
   * `lifecycle`). The entry goes in whole rather than per-field: a partial one fails the Home
   * parse and would poison the doc app-wide.
   */
  async putSpaceSummary(homeId, spaceId, summary) {
    const path = homePath(homeId);
    this.log.info("Putting Home space summary", { path, spaceId, summary });
    await this.adapter.updateDoc(path, { [`spaceSummary.${spaceId}`]: summary });
  }
  /**
   * Records ONE setup-checklist item's outcome in the `setupChecklist` map — a dot-path write, so
   * two items resolved at once can't drop each other's entry, and neither can revert a lifecycle
   * field the server just stamped. The marker goes in whole rather than per-field: a partial entry
   * fails the Home parse and would poison the doc app-wide.
   *
   * Home items only. A user item ('notifications', 'ask-rock', 'weekends') is a lesson that
   * outlives any one home — see BaseUserDao.putSetupChecklistMarker.
   */
  async putSetupChecklistMarker(homeId, item, marker) {
    const path = homePath(homeId);
    this.log.info("Putting Home setup checklist marker", { path, item, outcome: marker.outcome });
    await this.adapter.updateDoc(path, { [`setupChecklist.${item}`]: marker });
  }
  /**
   * Dismisses (or restores) the setup checklist for the WHOLE home — everyone who shares it, like
   * `doneAddingRooms`. One field, so it can't revert anything else on the doc.
   *
   * Restoring needs the delete sentinel: `{ field: undefined }` is a silent no-op in the adapter,
   * and there is no falsy Timestamp the schema would accept in its place.
   */
  async setSetupChecklistDismissed(homeId, dismissed) {
    const path = homePath(homeId);
    this.log.info("Setting Home setup checklist dismissal", { path, dismissed });
    const del = this.adapter.deleteFieldValue();
    await this.adapter.updateDoc(path, {
      setupChecklistDismissedAt: dismissed?.at ?? del,
      setupChecklistDismissedBy: dismissed?.by ?? del
    });
  }
  /**
   * Follows ONE recall topic for the whole home from `since`, or moves an existing follow's start. A dot-path
   * write plus an array transform on the query mirror, so two members changing different topics at once can't
   * drop each other's.
   */
  async followRecallTopic(homeId, topicId, since) {
    const path = homePath(homeId);
    this.log.info("Following Home recall topic", { path, topicId, since });
    await this.adapter.updateDoc(path, {
      [`recallTopicFollows.${topicId}`]: { since },
      recallTopicIds: this.arrayUnionValue(topicId)
    });
  }
  /** Stops following ONE recall topic: its follow and its query-mirror id go together. */
  async unfollowRecallTopic(homeId, topicId) {
    const path = homePath(homeId);
    this.log.info("Unfollowing Home recall topic", { path, topicId });
    await this.adapter.updateDoc(path, {
      [`recallTopicFollows.${topicId}`]: this.adapter.deleteFieldValue(),
      recallTopicIds: this.arrayRemoveValue(topicId)
    });
  }
  /**
   * Sets (or clears) ONE space's custom photo in the `spaceImages` map — a dot-path write, so two
   * spaces re-photographed at once can't drop each other's entry, and neither can revert a lifecycle
   * field the server just stamped. Passing no url clears the entry with the delete sentinel, which
   * reverts the space to its stock image; `{ [key]: undefined }` would be a silent no-op.
   */
  async putSpaceImage(homeId, spaceId, url) {
    const path = homePath(homeId);
    this.log.info("Putting Home space image", { path, spaceId, hasUrl: !!url });
    await this.adapter.updateDoc(path, {
      [`spaceImages.${spaceId}`]: url || this.adapter.deleteFieldValue()
    });
  }
  /**
   * Renames the home and moves it to a new zip. Clears `geo` — the old coordinates belong to the old
   * zip, and an absent `geo` is what tells the `updateHomeLocation` trigger to look the new one up —
   * and `waitlistedAt`, since whether the home sits in a served area is a question the new zip has to
   * answer again. Both need the delete sentinel; omitting them leaves the stale values in place.
   */
  async setHomeAddress(homeId, name, zip) {
    const path = homePath(homeId);
    this.log.info("Setting Home address", { path, zip });
    const del = this.adapter.deleteFieldValue();
    await this.adapter.updateDoc(path, { name, zip, geo: del, waitlistedAt: del });
  }
  async deleteHome(homeId) {
    this.log.info("Deleting home", { homeId });
    await this.updateHome(homeId, { active: false });
  }
  async restoreHome(homeId) {
    this.log.info("Restoring home", { homeId });
    await this.updateHome(homeId, { active: true });
  }
  /**
   * Lifecycle transition: the user declared setup done — `setting-up` → `reviewing`.
   * Points the home at the review doc for this submit (`planReviewId`) and clears any prior
   * `planReadyAt` so this review waits for its own eval to settle.
   */
  async submitHomeForReview(homeId, now, reviewId) {
    const path = homePath(homeId);
    this.log.info("Submitting home for review", { homeId, reviewId });
    const updates = {
      lifecycle: "reviewing",
      submittedForReviewAt: now,
      planReviewId: reviewId,
      planReadyAt: this.adapter.deleteFieldValue()
    };
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Re-points a `reviewing` home at a fresh review doc (a client-side retry, or a home that
   * never got one). Defensively clears `planReadyAt` — a retry must wait for its own run.
   */
  async restartHomeReview(homeId, reviewId) {
    const path = homePath(homeId);
    this.log.info("Restarting home review", { homeId, reviewId });
    const updates = {
      planReviewId: reviewId,
      planReadyAt: this.adapter.deleteFieldValue()
    };
    await this.adapter.updateDoc(path, updates);
  }
  /** Marks the submitted home's review as settled — the plan review can present it. */
  async markHomePlanReady(homeId, now) {
    this.log.info("Marking home plan ready", { homeId });
    await this.updateHome(homeId, { planReadyAt: now });
  }
  /**
   * Lifecycle transition: the user backed out of their review — `reviewing` → `setting-up`.
   * Clears the review stamps and the review pointer so the next submit starts a fresh review.
   */
  async returnHomeToSetup(homeId) {
    const path = homePath(homeId);
    this.log.info("Returning home to setup", { homeId });
    const updates = {
      lifecycle: "setting-up",
      submittedForReviewAt: this.adapter.deleteFieldValue(),
      planReadyAt: this.adapter.deleteFieldValue(),
      planReviewId: this.adapter.deleteFieldValue()
    };
    await this.adapter.updateDoc(path, updates);
  }
  /** Lifecycle transition: the user accepted their coverage plan — `reviewing` → `active`. */
  async acceptHomePlan(homeId, now, by) {
    this.log.info("Accepting home plan", { homeId, by });
    await this.updateHome(homeId, { lifecycle: "active", planAcceptedAt: now, planAcceptedBy: by });
  }
  async getHomeSpace(homeId, spaceId) {
    const path = homeSpacePath(homeId, spaceId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeSpaceSchema, path, this.log) : void 0;
  }
  /**
   * Marks a space's setup finished, recording the guide visit that did it when there was one.
   *
   * An UPSERT: a space can be finished before any home-space doc exists (a skip, or a first guided
   * run), so this merges rather than updating — an update would throw NOT_FOUND on the create case.
   * It writes only the fields it owns, which is the point: the previous whole-document write had to
   * read the doc, spread it, and write it back, so anything that landed in between was reverted.
   * `guideVisitIds` is appended with `arrayUnion` rather than restated, so two finishes racing
   * (a space guide and an equipment guide inside it) can't drop each other's visit.
   *
   * The read is only here to decide `createdAt` — stamped on the first finish, never restated, so
   * the doc keeps the instant setup actually began.
   */
  async markHomeSpaceFinished(homeId, spaceId, guideVisitId) {
    const path = homeSpacePath(homeId, spaceId);
    const existing = await this.getHomeSpace(homeId, spaceId);
    this.log.info("Marking HomeSpace finished", { path, guideVisitId });
    await this.adapter.setDoc(
      path,
      {
        object: "home-space",
        schema: 1,
        homeId,
        spaceId,
        status: "finished",
        ...existing?.createdAt ? {} : { createdAt: (/* @__PURE__ */ new Date()).toISOString() },
        ...guideVisitId ? { guideVisitIds: this.adapter.arrayUnionValue(guideVisitId) } : {}
      },
      { merge: true }
    );
  }
  async setHomeSpace(homeId, spaceId, data) {
    const path = homeSpacePath(homeId, spaceId);
    this.log.info("Setting HomeSpace", { path, data });
    await this.adapter.setDoc(path, data);
  }
};

// src/dao/BaseHomeEvalJobDao.ts
import { HomeEvalJobSchema } from "@rock/types";
var BaseHomeEvalJobDao = class extends BaseDao {
  constructor() {
    super("HomeEvalJobDao");
  }
  async getHomeEvalJob(jobId) {
    const path = homeEvalJobRunPath(jobId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeEvalJobSchema, path, this.log) : void 0;
  }
  async setHomeEvalJob(jobId, data) {
    const path = homeEvalJobRunPath(jobId);
    this.log.info("Setting HomeEvalJob", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateHomeEvalJob(jobId, updates) {
    const path = homeEvalJobRunPath(jobId);
    this.log.info("Updating HomeEvalJob", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseHomeEvalResultDao.ts
import { HomeEvalResultSchema } from "@rock/types";
var BaseHomeEvalResultDao = class extends BaseDao {
  constructor() {
    super("HomeEvalResultDao");
  }
  async getHomeEvalResult(resultId) {
    const path = homeEvalResultPath(resultId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeEvalResultSchema, path, this.log) : void 0;
  }
  async setHomeEvalResult(resultId, data) {
    const path = homeEvalResultPath(resultId);
    this.log.info("Setting HomeEvalResult", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateHomeEvalResult(resultId, updates) {
    const path = homeEvalResultPath(resultId);
    this.log.info("Updating HomeEvalResult", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseHomeEvalTriggerDao.ts
import { HomeEvalTriggerSchema } from "@rock/types";
var BaseHomeEvalTriggerDao = class extends BaseDao {
  constructor() {
    super("HomeEvalTriggerDao");
  }
  async getHomeEvalTrigger(homeId) {
    const path = homeEvalTriggerPath(homeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeEvalTriggerSchema, path, this.log) : void 0;
  }
  async setHomeEvalTrigger(homeId, data) {
    const path = homeEvalTriggerPath(homeId);
    this.log.info("Setting HomeEvalTrigger", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateHomeEvalTrigger(homeId, updates) {
    const path = homeEvalTriggerPath(homeId);
    this.log.info("Updating HomeEvalTrigger", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseHomeInviteDao.ts
import { HomeInviteSchema } from "@rock/types";
var BaseHomeInviteDao = class extends BaseDao {
  constructor() {
    super("HomeInviteDao");
  }
  async getHomeInvite(homeId, code) {
    const path = homeInvitePath(homeId, code);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeInviteSchema, path, this.log) : void 0;
  }
  async setHomeInvite(invite) {
    this.log.info("Setting HomeInvite", {
      homeId: invite.homeId,
      status: invite.status,
      invitedBy: invite.invitedBy
    });
    await this.adapter.setDoc(homeInvitePath(invite.homeId, invite.code), invite);
  }
  /** Takes the invite for `by`; false when it was no longer pending by then. */
  async acceptHomeInvite(homeId, code, by, now) {
    this.log.info("Accepting HomeInvite", { homeId, by });
    return this.compareAndSetDoc(homeInvitePath(homeId, code), {
      expect: { status: "pending" },
      updates: { status: "accepted", acceptedBy: by, acceptedAt: now }
    });
  }
  /**
   * Takes an invite back without waiting on the server, so it works offline; the rules refuse it if
   * the invite was accepted first. Server code uses the guarded {@link revokeHomeInvite}.
   */
  async takeBackHomeInvite(homeId, code, by, now) {
    this.log.info("Taking back HomeInvite", { homeId, by });
    await this.adapter.updateDoc(homeInvitePath(homeId, code), {
      status: "revoked",
      revokedBy: by,
      revokedAt: now
    });
  }
  /**
   * Claims the invite's one email for this delivery; false when another delivery claimed it first, or
   * the invite was taken back before its email could go.
   */
  async claimHomeInviteEmail(homeId, code) {
    this.log.info("Claiming HomeInvite email", { homeId });
    return this.compareAndSetDoc(homeInvitePath(homeId, code), {
      expect: { emailStatus: void 0, status: "pending" },
      updates: { emailStatus: "sending" }
    });
  }
  /** Settles a claimed email: sent, failed, or held for a reason. */
  async recordHomeInviteEmail(homeId, code, outcome) {
    this.log.info("Recording HomeInvite email", { homeId, ...outcome });
    const hold = outcome.status === "held" ? { emailHold: outcome.hold } : {};
    await this.adapter.updateDoc(homeInvitePath(homeId, code), { emailStatus: outcome.status, ...hold });
  }
  /** Takes a pending invite back; false when it had already been settled. */
  async revokeHomeInvite(homeId, code, by, now) {
    this.log.info("Revoking HomeInvite", { homeId, by });
    return this.compareAndSetDoc(homeInvitePath(homeId, code), {
      expect: { status: "pending" },
      updates: { status: "revoked", revokedBy: by, revokedAt: now }
    });
  }
};

// src/dao/BaseHomeMemberDao.ts
import { HomeMemberSchema } from "@rock/types";
var BaseHomeMemberDao = class extends BaseDao {
  constructor() {
    super("HomeMemberDao");
  }
  async getHomeMember(homeId, userId) {
    const path = homeMemberPath(homeId, userId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeMemberSchema, path, this.log) : void 0;
  }
  async setHomeMember(member) {
    const path = homeMemberPath(member.homeId, member.userId);
    this.log.info("Setting HomeMember", { path, role: member.role });
    await this.adapter.setDoc(path, member);
  }
  /** Adds the member: their doc and their place on the home's `memberIds`, in one batch. */
  async addHomeMember(member) {
    const path = homeMemberPath(member.homeId, member.userId);
    this.log.info("Adding HomeMember", { path, role: member.role });
    await this.commitBatch([
      { kind: "set", path, data: member },
      {
        kind: "update",
        path: homePath(member.homeId),
        updates: { memberIds: this.arrayUnionValue(member.userId) }
      }
    ]);
  }
  /** Takes the member out: off the home's `memberIds` and their doc gone, in one batch. */
  async removeHomeMember(homeId, userId) {
    const path = homeMemberPath(homeId, userId);
    this.log.info("Removing HomeMember", { path });
    await this.commitBatch([
      { kind: "update", path: homePath(homeId), updates: { memberIds: this.arrayRemoveValue(userId) } },
      { kind: "delete", path }
    ]);
  }
  /** Hands the home from one member to another: both roles and the home's `owner`, in one batch. */
  async transferHomeOwnership(homeId, from, to) {
    this.log.info("Transferring home ownership", { homeId, from, to });
    await this.commitBatch([
      { kind: "update", path: homeMemberPath(homeId, to), updates: { role: "owner" } },
      { kind: "update", path: homeMemberPath(homeId, from), updates: { role: "member" } },
      { kind: "update", path: homePath(homeId), updates: { owner: to } }
    ]);
  }
  /**
   * The member's name, email and avatar as the list shows them, each cleared when the profile lacks it;
   * a field update, so a doc removed meanwhile is not brought back.
   */
  async setHomeMemberProfile(homeId, userId, profile) {
    const path = homeMemberPath(homeId, userId);
    this.log.info("Setting HomeMember profile", { path, named: !!profile.name });
    await this.adapter.updateDoc(path, {
      name: profile.name ?? this.deleteFieldValue(),
      email: profile.email ?? this.deleteFieldValue(),
      imageUrl: profile.imageUrl ?? this.deleteFieldValue()
    });
  }
  async deleteHomeMember(homeId, userId) {
    const path = homeMemberPath(homeId, userId);
    this.log.info("Deleting HomeMember", { path });
    await this.adapter.deleteDoc(path);
  }
};

// src/dao/BaseHomeQuestionDao.ts
import { HomeQuestionSchema } from "@rock/types";
var BaseHomeQuestionDao = class extends BaseDao {
  constructor() {
    super("HomeQuestionDao");
  }
  async getQuestion(homeId, questionId) {
    const path = homeQuestionPath(homeId, questionId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeQuestionSchema, path, this.log) : void 0;
  }
  async setQuestion(question) {
    const path = homeQuestionPath(question.homeId, question.id);
    this.log.info("Setting HomeQuestion", { path, kind: question.kind, status: question.status });
    await this.adapter.setDoc(path, question);
  }
  /**
   * Close a question still open; false when it was already closed. With `expectUpdatedAt`, only the version
   * the caller decided on, so a re-ask landing in between is never closed.
   */
  async closeQuestion(homeId, questionId, status, now, expectUpdatedAt) {
    const path = homeQuestionPath(homeId, questionId);
    const closed = await this.adapter.compareAndSetDoc(path, {
      expect: { status: "open", ...expectUpdatedAt ? { updatedAt: expectUpdatedAt } : {} },
      updates: { status, closedAt: now, updatedAt: now }
    });
    if (closed) this.log.info("Closed HomeQuestion", { path, status });
    return closed;
  }
  /** A stale question stands again (its unit was restored): open, still counted as told. */
  async reopenQuestion(homeId, questionId, now, expectUpdatedAt) {
    const path = homeQuestionPath(homeId, questionId);
    const reopened = await this.adapter.compareAndSetDoc(path, {
      expect: { status: "stale", updatedAt: expectUpdatedAt },
      updates: { status: "open", closedAt: this.deleteFieldValue(), updatedAt: now }
    });
    this.log.info("Reopening HomeQuestion", { path, reopened });
    return reopened;
  }
  /** Take the one chance to tell the owner about an open question; the caller sends on true. */
  async claimNotification(homeId, questionId, now) {
    const path = homeQuestionPath(homeId, questionId);
    const claimed = await this.adapter.compareAndSetDoc(path, {
      expect: { status: "open", notifiedAt: void 0 },
      updates: { notifiedAt: now, updatedAt: now }
    });
    this.log.info("Claiming HomeQuestion notification", { path, claimed });
    return claimed;
  }
  /** Hidden until `until`. */
  async snooze(homeId, questionId, until, now, by) {
    const path = homeQuestionPath(homeId, questionId);
    this.log.info("Snoozing HomeQuestion", { path, until, by });
    await this.adapter.updateDoc(path, { snoozedUntil: until, snoozedBy: by, updatedAt: now });
  }
};

// src/dao/BaseHomeTaskSubscriptionDao.ts
import { HomeTaskSubscriptionSchema } from "@rock/types";
var BaseHomeTaskSubscriptionDao = class extends BaseDao {
  constructor() {
    super("HomeTaskSubscriptionDao");
  }
  async getHomeTaskSubscription(homeId, subscriptionId) {
    const path = homeTaskSubscriptionPath(homeId, subscriptionId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, HomeTaskSubscriptionSchema, path, this.log) : void 0;
  }
  async setHomeTaskSubscription(homeId, subscriptionId, data) {
    const path = homeTaskSubscriptionPath(homeId, subscriptionId);
    this.log.info("Setting HomeTaskSubscription", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateHomeTaskSubscription(homeId, subscriptionId, updates) {
    const path = homeTaskSubscriptionPath(homeId, subscriptionId);
    this.log.info("Updating HomeTaskSubscription", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async pauseHomeTaskSubscription(homeId, subscriptionId, now, by) {
    await this.updateHomeTaskSubscription(homeId, subscriptionId, {
      status: "paused",
      pausedAt: now,
      pausedBy: by,
      updatedAt: now
    });
  }
  /** The pause's stamps leave with the resume. */
  async resumeHomeTaskSubscription(homeId, subscriptionId, now) {
    await this.restoreHomeTaskSubscription(homeId, subscriptionId, "active", now);
  }
  /**
   * Brings a removed reminder back to `status`, which a pause never survives: a paused reminder can
   * be removed, and what comes back is a live one.
   */
  async restoreHomeTaskSubscription(homeId, subscriptionId, status, now) {
    const del = this.deleteFieldValue();
    await this.updateHomeTaskSubscription(homeId, subscriptionId, {
      status,
      pausedAt: del,
      pausedBy: del,
      updatedAt: now
    });
  }
  async setSubscriptionContact(homeId, subscriptionId, contactId) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Setting subscription contact", { homeId, subscriptionId, contactId });
    await this.updateHomeTaskSubscription(homeId, subscriptionId, { contactId, updatedAt: now });
  }
  async clearSubscriptionContact(homeId, subscriptionId) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Clearing subscription contact", { homeId, subscriptionId });
    await this.adapter.updateDoc(homeTaskSubscriptionPath(homeId, subscriptionId), {
      contactId: this.adapter.deleteFieldValue(),
      updatedAt: now
    });
  }
  async setSubscriptionTaskNotes(homeId, subscriptionId, taskNotes) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Setting subscription task notes", { homeId, subscriptionId, hasNotes: !!taskNotes });
    await this.adapter.updateDoc(homeTaskSubscriptionPath(homeId, subscriptionId), {
      taskNotes: taskNotes || this.adapter.deleteFieldValue(),
      updatedAt: now
    });
  }
};

// src/dao/BaseImageWritebackDao.ts
var BaseImageWritebackDao = class extends BaseDao {
  constructor() {
    super("ImageWritebackDao");
  }
  /**
   * Overwrites an `ImageOption`-shaped sub-object (e.g. `brand.logo`) with the uploaded URLs and
   * clears its transient `uploadPending` flag. Reads the doc first so a missing parent is reported
   * as retryable `doc-missing` rather than throwing (a blind `updateDoc` errors on an absent doc).
   */
  async writeFieldImage(docPath, fieldPath, urls) {
    const data = await this.adapter.getDoc(docPath);
    if (!data) {
      this.log.warn("Image writeback deferred: parent doc not found", { docPath, fieldPath });
      return "doc-missing";
    }
    this.log.info("Writing uploaded image to field", { docPath, fieldPath });
    await this.adapter.updateDoc(docPath, {
      [`${fieldPath}.url`]: urls.url,
      [`${fieldPath}.thumbnail`]: urls.thumbnail,
      [`${fieldPath}.uploadPending`]: this.adapter.deleteFieldValue()
    });
    return "written";
  }
  /**
   * Replaces a bare URL string field (e.g. `user.imageUrl`) with one of the uploaded URLs, but only while
   * it still holds `localValue`, the local file the upload was queued for. Anything else means the field
   * moved on (a newer photo, a revert, another device) and is reported `gone`. Reads the doc first so a
   * missing parent is reported as retryable `doc-missing` rather than throwing. The check reads the local
   * cache on purpose: a transaction would see only server state and miss a still-pending local write.
   */
  async writeUrlField(docPath, fieldPath, value, localValue) {
    const data = await this.adapter.getDoc(docPath);
    if (!data) {
      this.log.warn("Image writeback deferred: parent doc not found", { docPath, fieldPath });
      return "doc-missing";
    }
    if (getByPath(data, fieldPath) !== localValue) {
      this.log.info("Url field no longer holds the uploaded image, skipping", { docPath, fieldPath });
      return "gone";
    }
    this.log.info("Writing uploaded image to url field", { docPath, fieldPath });
    await this.adapter.updateDoc(docPath, { [fieldPath]: value });
    return "written";
  }
  /**
   * Writes the uploaded URLs onto the entry matching `imageId` in the doc's images collection
   * (the `images` map keyed by image id — see rock-types imageCollection.ts), clearing its
   * transient `uploadPending` flag. The write is scoped to that one map entry, so it can never
   * revert a concurrent writer's changes to sibling images — the lost-update bug that stranded
   * uploaded images on their local `file://` URLs when `images` was an array.
   *
   * Docs the array→map migration hasn't reached yet may still hold a legacy array at
   * `imagesPath`; those get the old in-place array patch (whole-array write, pre-migration risk
   * unchanged). Returns `doc-missing` when the parent doc doesn't exist yet (retryable) and
   * `gone` when the doc exists but the image is no longer on it (removed mid-upload; drop).
   */
  async writeImageEntry(docPath, imagesPath, imageId, urls) {
    const data = await this.adapter.getDoc(docPath);
    if (!data) {
      this.log.warn("Image writeback deferred: parent doc not found", { docPath, imagesPath, imageId });
      return "doc-missing";
    }
    const images = getByPath(data, imagesPath);
    if (Array.isArray(images)) {
      return this.writeLegacyArrayImage(docPath, imagesPath, imageId, urls, images);
    }
    if (!images || typeof images !== "object") {
      this.log.error("Images collection not found for image writeback", { docPath, imagesPath });
      return "gone";
    }
    const entry = images[imageId];
    if (!entry || typeof entry !== "object") {
      this.log.info("Image no longer present for writeback, skipping", { docPath, imagesPath, imageId });
      return "gone";
    }
    const { uploadPending: _, ...rest } = entry;
    this.log.info("Writing uploaded image into images map", { docPath, imagesPath, imageId });
    await this.adapter.updateDoc(docPath, {
      [`${imagesPath}.${imageId}`]: { ...rest, url: urls.url, thumbnail: urls.thumbnail }
    });
    return "written";
  }
  /** In-place patch of a legacy `ImageOption[]` array at rest (pre-migration doc). */
  async writeLegacyArrayImage(docPath, imagesPath, imageId, urls, images) {
    if (!images.some((img) => img.id === imageId)) {
      this.log.info("Image no longer present for writeback, skipping", { docPath, imagesPath, imageId });
      return "gone";
    }
    const updatedImages = images.map((img) => {
      if (img.id !== imageId) return img;
      const { uploadPending: _, ...rest } = img;
      return { ...rest, url: urls.url, thumbnail: urls.thumbnail };
    });
    this.log.info("Writing uploaded image into legacy images array", { docPath, imagesPath, imageId });
    await this.adapter.updateDoc(docPath, { [imagesPath]: updatedImages });
    return "written";
  }
};
function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => {
    if (acc && typeof acc === "object") return acc[key];
    return void 0;
  }, obj);
}

// src/dao/BaseInAppNotificationDao.ts
import { InAppNotificationSchema } from "@rock/types";
var BaseInAppNotificationDao = class extends BaseDao {
  constructor() {
    super("InAppNotificationDao");
  }
  async getNotification(userId, notificationId) {
    const path = notificationPath(userId, notificationId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, InAppNotificationSchema, path, this.log) : void 0;
  }
  async setNotification(userId, notificationId, data) {
    const path = notificationPath(userId, notificationId);
    this.log.info("Setting InAppNotification", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateNotification(userId, notificationId, updates) {
    const path = notificationPath(userId, notificationId);
    this.log.info("Updating InAppNotification", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseInfoTypeDao.ts
import { InfoTypeSchema } from "@rock/types";
var BaseInfoTypeDao = class extends BaseDao {
  constructor() {
    super("InfoTypeDao");
  }
  async getInfoType(typeId) {
    const path = infoTypePath(typeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, InfoTypeSchema, path, this.log) : void 0;
  }
  async setInfoType(typeId, data) {
    const path = infoTypePath(typeId);
    this.log.info("Setting InfoType", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateInfoType(typeId, updates) {
    const path = infoTypePath(typeId);
    this.log.info("Updating InfoType", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseLearnCacheDao.ts
import { LearnCacheSchema } from "@rock/types";
var BaseLearnCacheDao = class extends BaseDao {
  constructor() {
    super("LearnCacheDao");
  }
  async getLearnCache(key) {
    const path = learnCacheEntryPath(key);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, LearnCacheSchema, path, this.log) : void 0;
  }
  async setLearnCache(key, data) {
    const path = learnCacheEntryPath(key);
    this.log.info("Setting LearnCache", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateLearnCache(key, updates) {
    const path = learnCacheEntryPath(key);
    this.log.info("Updating LearnCache", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseLearnRequestDao.ts
import { LearnRequestSchema } from "@rock/types";
var BaseLearnRequestDao = class extends BaseDao {
  constructor() {
    super("LearnRequestDao");
  }
  async getLearnRequest(homeId, equipmentId, learnId) {
    const path = equipmentLearnRequestPath(homeId, equipmentId, learnId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, LearnRequestSchema, path, this.log) : void 0;
  }
  async setLearnRequest(homeId, equipmentId, learnId, data) {
    const path = equipmentLearnRequestPath(homeId, equipmentId, learnId);
    this.log.info("Setting LearnRequest", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateLearnRequest(homeId, equipmentId, learnId, updates) {
    const path = equipmentLearnRequestPath(homeId, equipmentId, learnId);
    this.log.info("Updating LearnRequest", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseLessonDao.ts
import { LessonSchema } from "@rock/types";
var BaseLessonDao = class extends BaseDao {
  constructor() {
    super("LessonDao");
  }
  async getLesson(homeId, lessonId) {
    const path = lessonPath(homeId, lessonId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, LessonSchema, path, this.log) : void 0;
  }
  async setLesson(homeId, lessonId, data) {
    const path = lessonPath(homeId, lessonId);
    this.log.info("Setting Lesson", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateLesson(homeId, lessonId, updates) {
    const path = lessonPath(homeId, lessonId);
    this.log.info("Updating Lesson", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Stamp that the homeowner opened the lesson. `firstReadAt` is written once and never moved, so it
   * stays a real "when did they first meet this" signal; `lastReadAt` tracks every visit. An already
   * `completed` or `dismissed` lesson is not walked backwards to `read` — nothing leaves the library,
   * and re-opening something you finished is not un-finishing it.
   *
   * Takes the whole `lesson` rather than an id because both decisions read its current state. That
   * snapshot comes from the caller and may be stale; the worst case is a re-stamped `firstReadAt` or
   * a redundant status write, neither of which loses anything, so it is not worth a transaction.
   */
  async markLessonRead(homeId, lesson, now, by) {
    const path = lessonPath(homeId, lesson.id);
    this.log.info("Marking Lesson read", { path, by });
    const advancesStatus = lesson.status === "unread";
    await this.adapter.updateDoc(path, {
      ...advancesStatus && { status: "read" },
      ...!lesson.firstReadAt && { firstReadAt: now },
      lastReadAt: now,
      readBy: by,
      updatedAt: now
    });
  }
  /** "I read this and I understand it." The terminal state, but the lesson stays in the library. */
  async completeLesson(homeId, lessonId, now, by) {
    const path = lessonPath(homeId, lessonId);
    this.log.info("Completing Lesson", { path, by });
    await this.adapter.updateDoc(path, { status: "completed", completedAt: now, completedBy: by, updatedAt: now });
  }
  /**
   * Undo "Got it, Mark Done" (or a dismissal): back to `read`, never `unread` — the homeowner has seen it,
   * and a lesson they opened must not come back wearing its unread dot. The completion stamps are
   * removed rather than left behind, since a stale `completedAt` on an open lesson would read as done
   * to the checklist's "resolved this week" rule. Removing a field needs the delete sentinel —
   * `{ field: undefined }` is a silent no-op.
   */
  async reopenLesson(homeId, lessonId, now) {
    const path = lessonPath(homeId, lessonId);
    this.log.info("Reopening Lesson", { path });
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, {
      status: "read",
      completedAt: del,
      completedBy: del,
      dismissedAt: del,
      dismissedBy: del,
      updatedAt: now
    });
  }
  /**
   * The homeowner's Maybe Later: the lesson comes up on `reviewAt`, which is today for a status card's
   * "Now". A dismissed one is reopened with it, to `read` as `reopenLesson` does, since nothing raises
   * a dismissed lesson whatever its date; an open one keeps its status, so an unread lesson keeps its
   * dot. Never called on a completed lesson, whose way back is `reopenLesson`. The week's fill dates
   * open lessons with `scheduleLessonReview` instead.
   */
  async deferLessonReview(homeId, lesson, reviewAt, now) {
    const path = lessonPath(homeId, lesson.id);
    this.log.info("Deferring Lesson review", { path, reviewAt });
    const reopens = lesson.status === "dismissed";
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, {
      ...reopens && { status: "read", dismissedAt: del, dismissedBy: del },
      reviewAt,
      updatedAt: now
    });
  }
  /**
   * Back to `unread`, from the list's quick actions — the homeowner wants its dot back. Callers offer it
   * only on an opened, unfinished lesson; the read stamps stay, since they record what happened.
   */
  async markLessonUnread(homeId, lessonId, now) {
    const path = lessonPath(homeId, lessonId);
    this.log.info("Marking Lesson unread", { path });
    await this.adapter.updateDoc(path, { status: "unread", updatedAt: now });
  }
  /** Not interested. Drops out of the fill's queue; stays browsable in the library. */
  async dismissLesson(homeId, lessonId, now, by) {
    const path = lessonPath(homeId, lessonId);
    this.log.info("Dismissing Lesson", { path, by });
    await this.adapter.updateDoc(path, { status: "dismissed", dismissedAt: now, dismissedBy: by, updatedAt: now });
  }
  /**
   * Queue the lesson to be raised on the weekend checklist on `reviewAt` (a Saturday). Leaves `status`
   * alone, exactly as the consideration equivalent does: the date governs when it comes up, not where
   * it sits in the library.
   */
  async scheduleLessonReview(homeId, lessonId, reviewAt, now) {
    const path = lessonPath(homeId, lessonId);
    this.log.info("Scheduling Lesson review", { path, reviewAt });
    await this.adapter.updateDoc(path, { reviewAt, updatedAt: now });
  }
};

// src/dao/BaseLessonTypeDao.ts
import { LessonTypeSchema } from "@rock/types";
var BaseLessonTypeDao = class extends BaseAppliesToOwnerDao {
  constructor() {
    super("LessonTypeDao");
  }
  appliesToPath(typeId) {
    return lessonTypePath(typeId);
  }
  async getLessonType(typeId) {
    const path = lessonTypePath(typeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, LessonTypeSchema, path, this.log) : void 0;
  }
  /** Whether the doc exists at all, parseable or not — `getLessonType` returns undefined for both. */
  async hasLessonType(typeId) {
    const path = lessonTypePath(typeId);
    return !!await this.adapter.getDoc(path);
  }
  async setLessonType(typeId, data) {
    const path = lessonTypePath(typeId);
    this.log.info("Setting LessonType", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateLessonType(typeId, updates) {
    const path = lessonTypePath(typeId);
    this.log.info("Updating LessonType", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Apply a Notion sync to a lesson type, clearing the fields the page no longer carries.
   *
   * A plain `updateDoc` cannot do this: the server adapter runs with `ignoreUndefinedProperties`, so
   * `{ aiWhenToShow: undefined }` is a silent no-op, and the doc would keep text the author removed.
   * The optional Notion-authored fields are therefore written explicitly, with the delete sentinel
   * when the page has cleared them.
   */
  async applyLessonTypeSync(typeId, updates) {
    const path = lessonTypePath(typeId);
    this.log.info("Applying LessonType sync", { path, updates });
    const del = this.deleteFieldValue();
    await this.adapter.updateDoc(path, {
      title: updates.title,
      lessonDocId: updates.lessonDocId ?? del,
      overview: updates.overview ?? del,
      aiWhenToShow: updates.aiWhenToShow ?? del,
      spaceId: updates.spaceId ?? del,
      defaultCriticality: updates.defaultCriticality ?? del,
      updatedAt: updates.updatedAt,
      ...updates.documentStatus !== void 0 && { documentStatus: updates.documentStatus }
    });
  }
};

// src/dao/BaseDocumentCoverageDao.ts
import { DocumentCoverageProjectionSchema } from "@rock/types";
var BaseDocumentCoverageDao = class extends BaseDao {
  constructor() {
    super("DocumentCoverageDao");
  }
  async getProjection(key) {
    const path = documentCoveragePath(key);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, DocumentCoverageProjectionSchema, path, this.log) : void 0;
  }
};

// src/dao/BaseDocumentSearchDao.ts
import { DocumentSearchSchema } from "@rock/types";
var BaseDocumentSearchDao = class extends BaseDao {
  constructor() {
    super("DocumentSearchDao");
  }
  async getDocumentSearch(modelId, searchId) {
    const path = documentSearchPath(modelId, searchId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, DocumentSearchSchema, path, this.log) : void 0;
  }
  async setDocumentSearch(search) {
    const path = documentSearchPath(search.modelId, search.id);
    this.log.info("Setting DocumentSearch", { path, status: search.status });
    await this.adapter.setDoc(path, search);
  }
};

// src/dao/BaseModelDao.ts
import { ModelSchema } from "@rock/types";
var BaseModelDao = class extends BaseDao {
  constructor() {
    super("ModelDao");
  }
  async getModel(modelId) {
    const path = modelPath(modelId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ModelSchema, path, this.log) : void 0;
  }
  async setModel(modelId, data) {
    const path = modelPath(modelId);
    this.log.info("Setting Model", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateModel(modelId, updates) {
    const path = modelPath(modelId);
    this.log.info("Updating Model", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /** Point an existing `brandSuggestion` at the brand request its name is waiting on. */
  async setBrandSuggestionRequest(modelId, requestId, now) {
    const path = modelPath(modelId);
    this.log.info("Pointing Model brand suggestion at request", { path, requestId });
    await this.adapter.updateDoc(path, { "brandSuggestion.requestId": requestId, updatedAt: now });
  }
  /**
   * Its request resolved without a brand for this model (not a brand, a shared nameplate its space doesn't
   * route): the name stays a suggestion for a human, and the model stops waiting on the request.
   */
  async releaseBrandSuggestionRequest(modelId, now) {
    const path = modelPath(modelId);
    this.log.info("Releasing Model brand suggestion from its request", { path });
    await this.adapter.updateDoc(path, { "brandSuggestion.requestId": this.deleteFieldValue(), updatedAt: now });
  }
  /**
   * Link the model's brand (and line) and clear its `brandSuggestion`: once linked, the suggestion — and
   * any brand request it pointed at — has nothing left to decide. Callers keep this fill-only by
   * checking `brandId` on a fresh read first.
   */
  async linkBrand(modelId, brandId, options, now) {
    const path = modelPath(modelId);
    this.log.info("Linking Model brand", { path, brandId, ...options });
    await this.adapter.updateDoc(path, {
      brandId,
      ...options.lineId ? { lineId: options.lineId } : {},
      brandSuggestion: this.deleteFieldValue(),
      updatedAt: now
    });
  }
  /** Fill the product line on a model already linked to the line's brand (a homeowner's pick, a resolved request). */
  async setModelLine(modelId, lineId, now) {
    const path = modelPath(modelId);
    this.log.info("Setting Model line", { path, lineId });
    await this.adapter.updateDoc(path, { lineId, updatedAt: now });
  }
  /**
   * A model merge's tombstone: archived and pointing at the winner, every open verdict answered (a merged
   * identity is neither parked, revisited nor awaiting a brand).
   */
  async markMerged(modelId, winnerId, now) {
    const path = modelPath(modelId);
    this.log.info("Marking Model merged", { path, winnerId });
    await this.adapter.updateDoc(path, {
      archivedAt: now,
      mergedInto: winnerId,
      brandSuggestion: this.deleteFieldValue(),
      parked: this.deleteFieldValue(),
      revisit: this.deleteFieldValue(),
      updatedAt: now
    });
  }
  /**
   * A brand merge moving the model to the winner. `enrichment.brandId` moves with it when it named the
   * loser, so the cached research still answers for the brand the model carries — otherwise
   * `researchStaleReason` would buy the research again.
   */
  async repointBrand(modelId, brandId, options, now) {
    const path = modelPath(modelId);
    this.log.info("Repointing Model brand", { path, brandId, ...options });
    await this.adapter.updateDoc(path, {
      brandId,
      ...options.lineId ? { lineId: options.lineId } : {},
      ...options.moveEnrichment ? { "enrichment.brandId": brandId } : {},
      updatedAt: now
    });
  }
};

// src/dao/BaseModelDocumentDao.ts
import { MAX_REPLACEMENT_HOPS, missingSuccessors } from "@rock/manuals";
import { ModelDocumentSchema } from "@rock/types";
var BaseModelDocumentDao = class extends BaseDao {
  constructor() {
    super("ModelDocumentDao");
  }
  async getModelDocument(docId) {
    const path = modelDocumentPath(docId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ModelDocumentSchema, path, this.log) : void 0;
  }
  /**
   * `known` plus every revision their replacement chains pass through, read round by round. Reads nothing
   * when none of them was replaced; a successor since unpublished is simply absent.
   */
  async loadReplacementChains(known) {
    const docs = new Map([...known].map((doc) => [doc.id, doc]));
    const tried = new Set(docs.keys());
    for (let hop = 0; hop < MAX_REPLACEMENT_HOPS; hop++) {
      const missing = missingSuccessors(docs.values(), tried);
      if (missing.length === 0) break;
      for (const id of missing) tried.add(id);
      const fetched = await Promise.all(missing.map((id) => this.getModelDocument(id)));
      for (const doc of fetched) if (doc) docs.set(doc.id, doc);
    }
    return docs;
  }
  /** Create or fully replace one document artifact (publish, trim output, migration). */
  async setModelDocument(document) {
    const path = modelDocumentPath(document.id);
    this.log.info("Setting ModelDocument", { path, tags: document.tags });
    await this.adapter.setDoc(path, document);
  }
  /**
   * Swap in a re-uploaded OpenAI Files id for an ingested document whose old one was deleted. Guarded on
   * `updatedAt`: a page cut or restore replaces the bytes in place and drops `ingest`, so a write landing
   * after one would cache an id for bytes the document no longer serves — and leave an `ingest` with no
   * status that the ingest claim never retries. `updatedAt` is left alone: this is a cache, not an edit.
   * Resolves false when the document changed (or vanished) since `document` was read.
   */
  async setDocumentOpenaiFileId(document, openaiFileId) {
    const path = modelDocumentPath(document.id);
    this.log.info("Setting ModelDocument OpenAI file id", { path, openaiFileId });
    return this.compareAndSetDoc(path, {
      expect: { updatedAt: document.updatedAt },
      updates: { "ingest.openaiFileId": openaiFileId }
    });
  }
  /** Delete one document artifact — the mirror trigger removes its public bytes. */
  async deleteModelDocument(docId) {
    const path = modelDocumentPath(docId);
    this.log.info("Deleting ModelDocument", { path });
    await this.adapter.deleteDoc(path);
  }
};

// src/dao/BaseModelDocumentCandidateDao.ts
import { ModelDocumentCandidateSchema } from "@rock/types";
var BaseModelDocumentCandidateDao = class extends BaseDao {
  constructor() {
    super("ModelDocumentCandidateDao");
  }
  async getCandidate(modelId, candidateId) {
    const path = modelDocumentCandidatePath(modelId, candidateId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ModelDocumentCandidateSchema, path, this.log) : void 0;
  }
  async setCandidate(candidate) {
    const path = modelDocumentCandidatePath(candidate.modelId, candidate.id);
    this.log.info("Setting ModelDocumentCandidate", { path, classification: candidate.verdict.classification });
    await this.adapter.setDoc(path, candidate);
  }
  /**
   * Store the per-page language analysis for these bytes (a field patch — never clobbers a concurrent
   * worker merge or human disposition). Overwrites any prior analysis: newest revision wins.
   */
  async setLanguageAnalysis(modelId, candidateId, analysis) {
    const path = modelDocumentCandidatePath(modelId, candidateId);
    this.log.info("Setting candidate language analysis", {
      path,
      outcome: analysis.proposal.outcome,
      totalPages: analysis.totalPages
    });
    await this.adapter.updateDoc(path, { languageAnalysis: analysis, updatedAt: (/* @__PURE__ */ new Date()).toISOString() });
  }
  /** Record the human's call on the trim proposal (see `DocumentTrimDecisionSchema`) — a field patch. */
  async setTrimDecision(modelId, candidateId, decision) {
    const path = modelDocumentCandidatePath(modelId, candidateId);
    this.log.info("Setting candidate trim decision", { path, action: decision.action });
    await this.adapter.updateDoc(path, { trimDecision: decision, updatedAt: (/* @__PURE__ */ new Date()).toISOString() });
  }
};

// src/dao/BaseModelNumberHelpCacheDao.ts
import { ModelNumberHelpCacheSchema } from "@rock/types";
var BaseModelNumberHelpCacheDao = class extends BaseDao {
  constructor() {
    super("ModelNumberHelpCacheDao");
  }
  async getModelNumberHelpCache(key) {
    const path = modelNumberHelpCacheEntryPath(key);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ModelNumberHelpCacheSchema, path, this.log) : void 0;
  }
  async setModelNumberHelpCache(key, data) {
    const path = modelNumberHelpCacheEntryPath(key);
    this.log.info("Setting ModelNumberHelpCache", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateModelNumberHelpCache(key, updates) {
    const path = modelNumberHelpCacheEntryPath(key);
    this.log.info("Updating ModelNumberHelpCache", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseModelNumberHelpRequestDao.ts
import { ModelNumberHelpRequestSchema } from "@rock/types";
var BaseModelNumberHelpRequestDao = class extends BaseDao {
  constructor() {
    super("ModelNumberHelpRequestDao");
  }
  async getModelNumberHelpRequest(homeId, helpId) {
    const path = modelNumberHelpRequestPath(homeId, helpId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ModelNumberHelpRequestSchema, path, this.log) : void 0;
  }
  async setModelNumberHelpRequest(homeId, helpId, data) {
    const path = modelNumberHelpRequestPath(homeId, helpId);
    this.log.info("Setting ModelNumberHelpRequest", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateModelNumberHelpRequest(homeId, helpId, updates) {
    const path = modelNumberHelpRequestPath(homeId, helpId);
    this.log.info("Updating ModelNumberHelpRequest", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseModelSpellingDao.ts
import { ModelSpellingSchema } from "@rock/types";
var BaseModelSpellingDao = class extends BaseDao {
  constructor() {
    super("ModelSpellingDao");
  }
  async getModelSpelling(spellingKey) {
    const path = modelSpellingPath(spellingKey);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ModelSpellingSchema, path, this.log) : void 0;
  }
};

// src/dao/BaseNotificationConfigDao.ts
import { NOTIFICATION_CONFIG_DEFAULTS, NotificationConfigDefaultsSchema, NotificationConfigSchema } from "@rock/types";
var BaseNotificationConfigDao = class extends BaseDao {
  constructor() {
    super("NotificationConfigDao");
  }
  async getNotificationConfig(userId, type) {
    const path = notificationConfigPath(userId, type);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, NotificationConfigSchema, path, this.log) : void 0;
  }
  /** Reads the editable per-type per-channel defaults singleton at `app/notification-config`. */
  async getDefaults() {
    const path = appNotificationConfigPath();
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, NotificationConfigDefaultsSchema, path, this.log) : void 0;
  }
  /**
   * Resolves a type's effective config for the channel listeners: the explicit defaults with the
   * user's sparse overrides applied per leaf (user wins only where they set an explicit value).
   * If the seeded `app/notification-config` doc lacks this type (a newly-added type whose doc hasn't
   * been re-seeded yet), falls back to the code-level {@link NOTIFICATION_CONFIG_DEFAULTS} — a read-only
   * fallback (no write), so the doc stays stale until re-seeded; a warn flags the drift.
   */
  async getMergedConfig(userId, type) {
    const [defaults, userConfig] = await Promise.all([
      this.getDefaults(),
      this.getNotificationConfig(userId, type)
    ]);
    return mergeConfig(resolveTypeDefaults(defaults, type, this.log), userConfig);
  }
  /** Sets (or clears) the opt-out flag for one channel of a notification type. */
  async setChannelSuppressed(userId, type, channel, suppressed) {
    await this.mergeUserConfig(userId, type, { [channel]: { suppressed } });
  }
  /** Records when the user received their first non-empty email for this type. */
  async markEmailFirstSent(userId, type, iso) {
    await this.mergeUserConfig(userId, type, { email: { firstSentAt: iso } });
  }
  /**
   * Records when this notification type was first emitted onto the bus for this user. Gates one-time
   * types (welcome, push-prompt) to a single emission ever — a producer checks
   * `getNotificationConfig(...)?.firstNotifiedAt` and skips if it's set. Stamped on the per-type config
   * doc (where send-state lives) rather than the user doc.
   */
  async markFirstNotified(userId, type, iso) {
    await this.mergeUserConfig(userId, type, { firstNotifiedAt: iso });
  }
  async mergeUserConfig(userId, type, partial) {
    const path = notificationConfigPath(userId, type);
    this.log.info("Setting NotificationConfig", { path, partial });
    await this.adapter.setDoc(
      path,
      {
        object: "notification-config",
        schema: 1,
        id: type,
        userId,
        updatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        ...partial
      },
      { merge: true }
    );
  }
};
function resolveTypeDefaults(defaults, type, log) {
  const seeded = defaults?.defaults[type];
  if (seeded) return seeded;
  log.warn(
    "notification-config doc missing defaults for type; using code defaults (re-seed app/notification-config)",
    {
      type
    }
  );
  return NOTIFICATION_CONFIG_DEFAULTS[type];
}
function mergeConfig(defaults, userConfig) {
  const userEmail = userConfig?.email ?? void 0;
  const email = {
    suppressed: userEmail?.suppressed ?? defaults.email.suppressed
  };
  if (userEmail?.firstSentAt) email.firstSentAt = userEmail.firstSentAt;
  return {
    email,
    push: { suppressed: userConfig?.push?.suppressed ?? defaults.push.suppressed },
    app: { suppressed: userConfig?.app?.suppressed ?? defaults.app.suppressed }
  };
}

// src/dao/BaseNotionWebhookEventDao.ts
import { NotionWebhookEventSchema } from "@rock/types";
var BaseNotionWebhookEventDao = class extends BaseDao {
  constructor() {
    super("NotionWebhookEventDao");
  }
  async getNotionWebhookEvent(eventId) {
    const path = notionWebhookEventPath(eventId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, NotionWebhookEventSchema, path, this.log) : void 0;
  }
  async setNotionWebhookEvent(eventId, data) {
    const path = notionWebhookEventPath(eventId);
    this.log.info("Setting NotionWebhookEvent", { path, type: data.type });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
};

// src/dao/BasePlanReviewDao.ts
import { PlanReviewSchema } from "@rock/types";
var BasePlanReviewDao = class extends BaseDao {
  constructor() {
    super("PlanReviewDao");
  }
  async getPlanReview(homeId, reviewId) {
    const path = planReviewPath(homeId, reviewId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, PlanReviewSchema, path, this.log) : void 0;
  }
  async setPlanReview(homeId, reviewId, data) {
    const path = planReviewPath(homeId, reviewId);
    this.log.info("Setting PlanReview", { path });
    await this.adapter.setDoc(path, data);
  }
  /**
   * Atomically move a review forward only if it still looks like `expect` — see
   * `DbAdapter.compareAndSetDoc`. Resolves false when someone else got there first, which is a
   * normal outcome for a trigger that can see the same doc twice, not an error.
   */
  async claimPlanReview(homeId, reviewId, args) {
    const path = planReviewPath(homeId, reviewId);
    const claimed = await this.compareAndSetDoc(path, args);
    this.log.info(claimed ? "Claimed PlanReview" : "PlanReview already claimed", { path, ...args });
    return claimed;
  }
  async updatePlanReview(homeId, reviewId, updates) {
    const path = planReviewPath(homeId, reviewId);
    this.log.info("Updating PlanReview", { path, fields: Object.keys(updates) });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseProcessHowOftenResultDao.ts
import { ProcessHowOftenResultSchema } from "@rock/types";
var BaseProcessHowOftenResultDao = class extends BaseDao {
  constructor() {
    super("ProcessHowOftenResultDao");
  }
  async getProcessHowOftenResult(resultId) {
    const path = processHowOftenResultPath(resultId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, ProcessHowOftenResultSchema, path, this.log) : void 0;
  }
  async setProcessHowOftenResult(resultId, data) {
    const path = processHowOftenResultPath(resultId);
    this.log.info("Setting ProcessHowOftenResult", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateProcessHowOftenResult(resultId, updates) {
    const path = processHowOftenResultPath(resultId);
    this.log.info("Updating ProcessHowOftenResult", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BasePropertyLookupRequestDao.ts
import { PropertyLookupRequestSchema } from "@rock/types";
var BasePropertyLookupRequestDao = class extends BaseDao {
  constructor() {
    super("PropertyLookupRequestDao");
  }
  async getPropertyLookupRequest(homeId, requestId) {
    const path = propertyLookupRequestPath(homeId, requestId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, PropertyLookupRequestSchema, path, this.log) : void 0;
  }
  async setPropertyLookupRequest(homeId, requestId, data) {
    const path = propertyLookupRequestPath(homeId, requestId);
    this.log.info("Setting PropertyLookupRequest", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updatePropertyLookupRequest(homeId, requestId, updates) {
    const path = propertyLookupRequestPath(homeId, requestId);
    this.log.info("Updating PropertyLookupRequest", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseRecallDao.ts
import { recallKey, RECALLS_STATE_ID, RecallKeySchema, RecallSchema, RecallsStateSchema } from "@rock/types";
import { shallowEqual } from "@rock/util";
var RECLASSIFIABLE_RECALL_STATUSES = [
  "classified",
  "draft",
  "approved"
];
var RecallChangedError = class extends Error {
  constructor(recallId) {
    super(`Recall ${recallId} changed since it was read`);
    this.name = "RecallChangedError";
  }
};
var BaseRecallDao = class extends BaseDao {
  constructor() {
    super("RecallDao");
  }
  async getRecall(recallId) {
    const path = recallPath(recallId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RecallSchema, path, this.log) : void 0;
  }
  async getRecallKey(source, sourceId) {
    const path = recallKeyPath(recallKey(source, sourceId));
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RecallKeySchema, path, this.log) : void 0;
  }
  /** A known recall republished with an unchanged notice: only the publish date moves. */
  async touchLastPublished(recallId, lastPublishedAt, now) {
    const path = recallPath(recallId);
    this.log.info("Touching Recall publish date", { path, lastPublishedAt });
    await this.adapter.updateDoc(path, { lastPublishedAt, updatedAt: now });
  }
  /**
   * The page flag alone, when a read of the source leaves the notice as it was. `updatedAt` is left alone
   * for the same reason as in `setImages`: the notice did not change.
   */
  async setPageUnavailable(recallId, pageUnavailable) {
    const path = recallPath(recallId);
    this.log.info("Setting Recall page flag", { path, pageUnavailable: !!pageUnavailable });
    await this.adapter.updateDoc(path, { pageUnavailable: pageUnavailable ?? this.deleteFieldValue() });
  }
  /**
   * The notice's images, swapped for our Storage copies. `updatedAt` is left alone: the copies show the
   * same photos, and the guarded writes compare on it, so a rehost must not fail an admin's or the
   * pipeline's write in flight.
   */
  async setImages(recallId, images) {
    const path = recallPath(recallId);
    this.log.info("Setting Recall images", { path, count: images.length });
    await this.adapter.updateDoc(path, { images });
  }
  /**
   * A known recall whose notice text CHANGED: the new text replaces the old and both stages run again.
   * An approved recall keeps its status and its `rules` (matching continues on them); its next process
   * lands in `draftRules`. A rejected recall stays rejected — a text edit at the source does not undo a
   * "not ours". Anything else drops back to `new`.
   */
  async replaceNotice(recall, notice, now) {
    const path = recallPath(recall.id);
    const status = statusAfterNoticeChange(recall.status);
    this.log.info("Replacing Recall notice", { path, status });
    await this.guarded(recall, this.toFieldPaths({ ...notice, status, updatedAt: now }));
  }
  /**
   * Stage 1 complete: the classification and `typed`. Only a `new` recall changes status (to
   * `classified`); a reclassify of a draft, approved or rejected recall leaves the status as the
   * reviewer left it.
   */
  async recordClassification(recall, write) {
    const path = recallPath(recall.id);
    const typed = write.classification.typeIds.length > 0;
    this.log.info("Recording Recall classification", { path, typed });
    await this.guarded(recall, {
      classification: write.classification,
      typed,
      activeTopicIds: activeTopicIdsFor(recall, write.classification.topicIds),
      ...recall.status === "new" ? { status: "classified" } : {},
      classifyVersion: write.classification.classifyVersion,
      classifiedAt: write.now,
      aiCalls: this.arrayUnionValue(...write.aiCalls),
      updatedAt: write.now
    });
  }
  /**
   * Stage 3 complete. A classified (or rejected-then-reprocessed) recall becomes a `draft` with the rules
   * live for review. An approved recall keeps matching on its current rules and brands and receives the
   * new ones as `draftRules` / `draftBrandIds`, which `approve` promotes together.
   */
  async recordProcessing(recall, write) {
    const path = recallPath(recall.id);
    const approved = recall.status === "approved";
    this.log.info("Recording Recall processing", { path, approved, modelHits: write.dryRun.modelIds.length });
    await this.guarded(recall, {
      extractions: write.extractions,
      ...approved ? { draftRules: write.rules, draftBrandIds: write.brandIds } : { rules: write.rules, brandIds: write.brandIds, status: "draft" },
      verification: write.verification,
      brandRequestIds: write.brandRequestIds,
      dryRun: write.dryRun,
      rulesVersion: write.rulesVersion,
      processedAt: write.now,
      aiCalls: this.arrayUnionValue(...write.aiCalls),
      updatedAt: write.now
    });
  }
  /** A stage that failed: keep the status, record the attempt so admin and the retry can see it. */
  async recordAiFailure(recallId, calls, now) {
    const path = recallPath(recallId);
    this.log.info("Recording Recall AI failure", { path, errors: calls.map((call) => call.error) });
    await this.adapter.updateDoc(path, { aiCalls: this.arrayUnionValue(...calls), updatedAt: now });
  }
  /**
   * Admin edit of the classification, as `@rock/recalls` planned it (`planClassificationEdit` /
   * `planRulingLift`). Refused on a recall the classifier never finished: a partial classification would
   * fail the schema on every read.
   */
  async setClassificationEdit(recall, write, now) {
    if (!recall.classification) throw new Error(`Recall ${recall.id} is not classified yet`);
    const path = recallPath(recall.id);
    this.log.info("Setting Recall classification edit", {
      path,
      typeIds: write.typeIds,
      ruledOutTypeIds: write.ruledOutTypeIds
    });
    await this.guarded(recall, {
      "classification.typeIds": write.typeIds,
      "classification.productKind": write.productKind,
      "classification.ruledOutTypeIds": write.ruledOutTypeIds,
      "classification.adminEdited": write.adminEdited,
      "classification.suggestedTypeIds": write.suggestedTypeIds,
      "classification.hasSuggestions": write.hasSuggestions,
      typed: write.typeIds.length > 0,
      updatedAt: now
    });
  }
  /**
   * Admin edit of the FYI topics, as `@rock/recalls` planned it (`planTopicsEdit` / `planTopicRuleOut`). On a
   * live recall `activeTopicIds` follows, and the recall's trigger re-applies it to the homes.
   */
  async setTopics(recall, write, now) {
    if (!recall.classification) throw new Error(`Recall ${recall.id} is not classified yet`);
    const path = recallPath(recall.id);
    this.log.info("Setting Recall topics", { path, topicIds: write.topicIds, ruledOut: write.ruledOutTopicIds });
    await this.guarded(recall, {
      "classification.topicIds": write.topicIds,
      "classification.topicsAdminEdited": write.topicsAdminEdited,
      "classification.ruledOutTopicIds": write.ruledOutTopicIds,
      "classification.suggestedTopicIds": write.suggestedTopicIds,
      "classification.hasSuggestions": write.hasSuggestions,
      activeTopicIds: activeTopicIdsFor(recall, write.topicIds),
      updatedAt: now
    });
  }
  /**
   * Replace a rules set wholesale (an admin accepted, added or suppressed an identifier — computed by the
   * pure helpers in `@rock/recalls`) together with its re-verification. Arrays are values, so there is
   * no per-element patch.
   */
  async setRules(recall, field, rules, verification, now) {
    const path = recallPath(recall.id);
    this.log.info("Setting Recall rules", { path, field, modelRules: rules.modelRules.length });
    await this.guarded(recall, { [field]: rules, verification, updatedAt: now });
  }
  /**
   * Admin re-resolved the brands (picked or removed one); `activeBrandIds` follows while approved. While a
   * re-process waits in `draftRules`, the edit lands on `draftBrandIds` instead — the live gate changes
   * only through Approve, so an edit under review never re-applies the recall on the old rules.
   */
  async setBrandIds(recall, brandIds, now) {
    const path = recallPath(recall.id);
    if (recall.draftRules) {
      this.log.info("Setting Recall draft brands", { path, brandIds });
      await this.guarded(recall, { draftBrandIds: brandIds, updatedAt: now });
      return;
    }
    this.log.info("Setting Recall brands", { path, brandIds });
    await this.guarded(recall, {
      brandIds,
      activeBrandIds: activeBrandIdsFor(recall, brandIds),
      updatedAt: now
    });
  }
  /**
   * A brand merge rewriting the gate: `rewrite` runs over `brandIds` and, when present, `draftBrandIds`,
   * so both the live gate and a waiting re-process follow the merge; `activeBrandIds` tracks `brandIds`
   * while approved. Unlike `setBrandIds` this touches every array — a merge is a catalog fact, not an
   * admin edit under review. Writes nothing when neither array changes.
   */
  async rewriteBrandIds(recall, rewrite, now) {
    const path = recallPath(recall.id);
    const brandIds = rewrite(recall.brandIds);
    const draftBrandIds = recall.draftBrandIds ? rewrite(recall.draftBrandIds) : void 0;
    const changed = !shallowEqual(brandIds, recall.brandIds) || !!draftBrandIds && !shallowEqual(draftBrandIds, recall.draftBrandIds);
    if (!changed) return false;
    this.log.info("Rewriting Recall brands", { path, brandIds, draftBrandIds });
    await this.guarded(recall, {
      brandIds,
      activeBrandIds: activeBrandIdsFor(recall, brandIds),
      ...draftBrandIds ? { draftBrandIds } : {},
      updatedAt: now
    });
    return true;
  }
  /**
   * An equipment-type retire moving the classification onto the replacement type. Like `rewriteBrandIds`
   * it's a catalog fact, not an admin edit, so `adminEdited` is left as it was, and so are the rulings: they
   * name the exact type an admin removed, not whatever later absorbs it. A ruling on the replacement
   * itself is lifted, as an admin adding that type back would lift it. Writes nothing when the ids don't
   * change.
   */
  async rewriteClassificationTypeIds(recall, rewrite, now) {
    if (!recall.classification) return false;
    const typeIds = rewrite(recall.classification.typeIds);
    if (shallowEqual(typeIds, recall.classification.typeIds)) return false;
    const ruledOut = recall.classification.ruledOutTypeIds;
    const ruledOutTypeIds = ruledOut?.filter((id) => !typeIds.includes(id));
    const liftsRuling = !!ruledOut && ruledOutTypeIds?.length !== ruledOut.length;
    this.log.info("Rewriting Recall classification types", { path: recallPath(recall.id), typeIds });
    await this.guarded(recall, {
      "classification.typeIds": typeIds,
      ...liftsRuling ? { "classification.ruledOutTypeIds": ruledOutTypeIds } : {},
      updatedAt: now
    });
    return true;
  }
  /**
   * Approve: the rules go live, the brands and topics become active. When a re-process is waiting in
   * `draftRules`, approving promotes it (and its brands) over the current rules. `brandIds`, when given,
   * is the gate as the catalog resolves it now, written in the same guarded write as the approval. A recall
   * with topics may go live without rules: it reaches homes through its topics alone.
   */
  async approve(recall, reviewedBy, now, brandIds) {
    const path = recallPath(recall.id);
    const rules = recall.draftRules ?? recall.rules;
    const topicIds = recall.classification?.topicIds ?? [];
    if (!rules && !topicIds.length) throw new Error(`Recall ${recall.id} has no rules or topics to approve`);
    const gate = brandIds ?? (recall.draftRules ? recall.draftBrandIds ?? recall.brandIds : recall.brandIds);
    this.log.info("Approving Recall", { path, promotedDraft: !!recall.draftRules });
    await this.guarded(recall, {
      status: "approved",
      ...recall.draftRules ? { rules, draftRules: this.deleteFieldValue(), draftBrandIds: this.deleteFieldValue() } : {},
      brandIds: gate,
      activeBrandIds: activeBrandIdsFor({ status: "approved" }, gate),
      activeTopicIds: topicIds,
      approvedAt: now,
      reviewedBy,
      reviewedAt: now,
      rejectReason: this.deleteFieldValue(),
      rejectNote: this.deleteFieldValue(),
      updatedAt: now
    });
  }
  /** Reject: kept and filterable; nothing of it can match a unit any more, and no re-review is pending. */
  async reject(recall, rejection, now) {
    const path = recallPath(recall.id);
    this.log.info("Rejecting Recall", { path, reason: rejection.reason });
    await this.guarded(recall, {
      status: "rejected",
      activeBrandIds: [],
      activeTopicIds: [],
      draftRules: this.deleteFieldValue(),
      draftBrandIds: this.deleteFieldValue(),
      approvedAt: this.deleteFieldValue(),
      rejectReason: rejection.reason,
      rejectNote: rejection.note ?? this.deleteFieldValue(),
      reviewedBy: rejection.reviewedBy,
      reviewedAt: now,
      updatedAt: now
    });
  }
  /**
   * Reopen an approved or rejected recall for review: back to `draft` when it has rules, else
   * `classified` (where a topic-only recall waits for the Topics tab's approval again). A waiting
   * re-process becomes the rules under review (with its brands), since a draft keeps its rules in
   * `rules` — left in `draftRules`, Approve would later promote it unseen.
   */
  async reopen(recall, reviewedBy, now) {
    const path = recallPath(recall.id);
    const rules = recall.draftRules ?? recall.rules;
    const status = rules ? "draft" : "classified";
    this.log.info("Reopening Recall", { path, status, promotedDraft: !!recall.draftRules });
    await this.guarded(recall, {
      status,
      activeBrandIds: [],
      activeTopicIds: [],
      ...recall.draftRules ? {
        rules: recall.draftRules,
        brandIds: recall.draftBrandIds ?? recall.brandIds,
        draftRules: this.deleteFieldValue(),
        draftBrandIds: this.deleteFieldValue()
      } : {},
      approvedAt: this.deleteFieldValue(),
      rejectReason: this.deleteFieldValue(),
      rejectNote: this.deleteFieldValue(),
      reviewedBy,
      reviewedAt: now,
      updatedAt: now
    });
  }
  /**
   * An untyped draft back to the No Matched Type backlog: `classified`, its processing output dropped (a
   * re-process pays for it again) and the classification handed back to the classifier, so a reclassify
   * against a grown catalog can type it, though never with a ruled-out type. The `aiCalls` ledger stays.
   */
  async returnToUntypedBacklog(recall, reviewedBy, now) {
    if (!recall.classification) throw new Error(`Recall ${recall.id} is not classified yet`);
    if (recall.status !== "draft" || recall.typed) {
      throw new Error(`Recall ${recall.id} is not an untyped draft`);
    }
    const path = recallPath(recall.id);
    this.log.info("Returning Recall to the untyped backlog", { path });
    await this.guarded(recall, {
      status: "classified",
      "classification.adminEdited": this.deleteFieldValue(),
      rules: this.deleteFieldValue(),
      extractions: this.deleteFieldValue(),
      verification: this.deleteFieldValue(),
      dryRun: this.deleteFieldValue(),
      brandIds: [],
      brandRequestIds: this.deleteFieldValue(),
      rulesVersion: this.deleteFieldValue(),
      processedAt: this.deleteFieldValue(),
      reviewedBy,
      reviewedAt: now,
      updatedAt: now
    });
  }
  /**
   * A recomputed Impact Preview. `updatedAt` stays put: the preview edits nothing a verdict reads, so it is
   * no reason for the admin's open page, or anything guarded on `updatedAt`, to see the recall as changed.
   */
  async setDryRun(recall, dryRun) {
    const path = recallPath(recall.id);
    this.log.info("Setting Recall impact preview", { path, modelHits: dryRun.modelIds.length });
    await this.guarded(recall, { dryRun });
  }
  /** Admin edit of the headline; an empty edit clears it and hands it back to the classifier. */
  async setHeadline(recall, headline, now) {
    if (!recall.classification) throw new Error(`Recall ${recall.id} is not classified yet`);
    const path = recallPath(recall.id);
    const trimmed = headline.trim();
    this.log.info("Setting Recall headline", { path, cleared: !trimmed });
    await this.guarded(recall, {
      "classification.headline": trimmed || this.deleteFieldValue(),
      "classification.headlineAdminEdited": trimmed ? true : this.deleteFieldValue(),
      updatedAt: now
    });
  }
  /** Admin edit of the homeowner-facing guidance; an empty edit clears it. */
  async setAdditionalGuidance(recall, additionalGuidance, now) {
    const path = recallPath(recall.id);
    const trimmed = additionalGuidance.trim();
    this.log.info("Setting Recall additional guidance", { path, cleared: !trimmed });
    await this.guarded(recall, {
      additionalGuidance: trimmed || this.deleteFieldValue(),
      updatedAt: now
    });
  }
  async setSupersedes(recall, supersedesRecallId, now) {
    const path = recallPath(recall.id);
    this.log.info("Setting Recall supersedes link", { path, supersedesRecallId });
    await this.guarded(recall, {
      supersedesRecallId: supersedesRecallId ?? this.deleteFieldValue(),
      updatedAt: now
    });
  }
  // --- app/recalls-state ---
  async getRecallsState() {
    const path = appRecallsStatePath();
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RecallsStateSchema, path, this.log) : void 0;
  }
  /**
   * A recall went live or was withdrawn: every model's `recallsCheckedEpoch` is now behind, so the next
   * enrichment pass checks it against the approved recalls of its brand. Read-then-write rather than an
   * atomic increment — approvals are a human's clicks, never concurrent — and the new epoch is returned.
   */
  async bumpRecallsEpoch(now) {
    const state = await this.getRecallsState();
    const recallsEpoch = (state?.recallsEpoch ?? 0) + 1;
    await this.updateRecallsState({ recallsEpoch }, now);
    return recallsEpoch;
  }
  /**
   * Write onto the singleton, creating it on first use (`recallsEpoch` starts at 0). Once it exists the
   * write is an update, so a map such as `untypedKindCounts` is REPLACED — a merge would deep-merge it
   * and a kind whose count fell to zero would keep its old number forever.
   */
  async updateRecallsState(updates, now) {
    const path = appRecallsStatePath();
    this.log.info("Updating recalls state", { path, keys: Object.keys(updates) });
    const existing = await this.adapter.getDoc(path);
    if (existing) {
      await this.adapter.updateDoc(path, { ...updates, updatedAt: now });
      return;
    }
    const seed = {
      object: "recalls-state",
      schema: 1,
      id: RECALLS_STATE_ID,
      recallsEpoch: 0,
      updatedAt: now
    };
    await this.adapter.setDoc(path, { ...seed, ...updates });
  }
  /**
   * The one write primitive the transitions share: apply `updates` only while the recall is still in the
   * status and at the `updatedAt` it was read with. A miss means someone moved it first.
   */
  async guarded(recall, updates) {
    const expect = { status: recall.status, updatedAt: recall.updatedAt };
    const applied = await this.adapter.compareAndSetDoc(recallPath(recall.id), { expect, updates });
    if (!applied) throw new RecallChangedError(recall.id);
  }
};
function activeBrandIdsFor(recall, brandIds) {
  return recall.status === "approved" ? brandIds : [];
}
function activeTopicIdsFor(recall, topicIds) {
  return recall.status === "approved" ? topicIds : [];
}
function statusAfterNoticeChange(status) {
  return status === "approved" || status === "rejected" ? status : "new";
}

// src/dao/BaseRecallJobDao.ts
import { RecallJobSchema } from "@rock/types";
var BaseRecallJobDao = class extends BaseDao {
  constructor() {
    super("RecallJobDao");
  }
  async getRecallJob(jobId) {
    const path = recallJobPath(jobId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RecallJobSchema, path, this.log) : void 0;
  }
  async setRecallJob(job) {
    const path = recallJobPath(job.id);
    this.log.info("Setting RecallJob", { path, kind: job.request.kind });
    await this.adapter.setDoc(path, job);
  }
  async updateRecallJob(jobId, updates) {
    const path = recallJobPath(jobId);
    this.log.info("Updating RecallJob", { path, status: updates.status });
    await this.adapter.updateDoc(path, this.toFieldPaths(updates));
  }
  /** Atomically take a `requested` job; false means another invocation owns it. */
  async claimRecallJob(jobId, eventId, now) {
    const path = recallJobPath(jobId);
    const claimed = await this.adapter.compareAndSetDoc(path, {
      expect: { status: "requested" },
      updates: { status: "running", startedAt: now, updatedAt: now, eventId }
    });
    this.log.info("Claiming RecallJob", { path, claimed });
    return claimed;
  }
};

// src/dao/BaseRecallMatchDao.ts
import { RecallMatchSchema } from "@rock/types";
var BaseRecallMatchDao = class extends BaseDao {
  constructor() {
    super("RecallMatchDao");
  }
  async getRecallMatch(recallId, modelId) {
    const path = recallMatchPath(recallId, modelId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RecallMatchSchema, path, this.log) : void 0;
  }
  async setRecallMatch(match) {
    const path = recallMatchPath(match.recallId, match.modelId);
    this.log.info("Setting RecallMatch", { path, strength: match.strength });
    await this.adapter.setDoc(path, match);
  }
  /** A brand merge: the match's brand follows its model. `sameMatch` ignores brand, so a re-apply never would. */
  async repointMatchBrand(recallId, modelId, brandId) {
    const path = recallMatchPath(recallId, modelId);
    this.log.info("Repointing RecallMatch brand", { path, brandId });
    await this.adapter.updateDoc(path, { brandId });
  }
  async deleteRecallMatch(recallId, modelId) {
    const path = recallMatchPath(recallId, modelId);
    this.log.info("Deleting RecallMatch", { path });
    await this.adapter.deleteDoc(path);
  }
};

// src/dao/BaseRecallTopicDao.ts
import { RecallTopicSchema } from "@rock/types";
var BaseRecallTopicDao = class extends BaseDao {
  constructor() {
    super("RecallTopicDao");
  }
  async getRecallTopic(topicId) {
    const path = recallTopicPath(topicId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RecallTopicSchema, path, this.log) : void 0;
  }
  async setRecallTopic(topic) {
    const path = recallTopicPath(topic.id);
    this.log.info("Setting RecallTopic", { path, title: topic.title });
    await this.adapter.setDoc(path, topic);
  }
};

// src/dao/BaseRecallVerdictDao.ts
import { RecallVerdictSchema } from "@rock/types";
var BaseRecallVerdictDao = class extends BaseDao {
  constructor() {
    super("RecallVerdictDao");
  }
  async getRecallVerdict(key) {
    const path = recallVerdictPath(key);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RecallVerdictSchema, path, this.log) : void 0;
  }
  /**
   * Whether the unit's verdict at its pre-migration path was already told or answered. Only for the deploy
   * window before migration 20261024 runs; delete with `legacyRecallVerdictPath`.
   */
  async legacyVerdictSettled(key) {
    const data = await this.adapter.getDoc(legacyRecallVerdictPath(key));
    return !!(data?.notifiedAt || data?.silencedAt || data?.resolution || data?.acceptedAt);
  }
  async setRecallVerdict(verdict) {
    const path = recallVerdictPath(verdict);
    this.log.info("Setting RecallVerdict", { path, verdict: verdict.verdict });
    await this.adapter.setDoc(path, verdict);
  }
  /**
   * The server's evaluation over the doc: each field it owns is replaced whole (an `evidence` or
   * `display` key the evaluation no longer has is gone, not deep-merged back, and so is a `modelId` it no
   * longer carries), the homeowner's answers (`resolution`, `typeConfirmedAt`, `acceptedAt`) and the
   * notification stamps are never touched, and a withdrawal is lifted — the recall applies to this unit
   * again. Only a doc that does not exist yet is created by a merge, so a claim another pass stamped in
   * between survives.
   */
  async upsertEvaluation(evaluation) {
    const path = recallVerdictPath(evaluation);
    const updates = {
      ...evaluation,
      ...evaluation.scope === "equipment" ? { modelId: evaluation.modelId ?? this.deleteFieldValue() } : {},
      withdrawn: this.deleteFieldValue()
    };
    const replaced = await this.adapter.compareAndSetDoc(path, { expect: {}, updates });
    this.log.info("Upserting RecallVerdict evaluation", { path, verdict: evaluation.verdict, created: !replaced });
    if (!replaced) await this.adapter.setDoc(path, updates, { merge: true });
  }
  /**
   * Take the one chance to tell the home: succeeds only while no pass has notified or silenced this verdict
   * and the homeowner has not already answered it. The caller sends on true and releases on a failed send.
   */
  async claimNotification(verdict, now) {
    const path = recallVerdictPath(verdict);
    const claimed = await this.adapter.compareAndSetDoc(path, {
      expect: { notifiedAt: void 0, silencedAt: void 0, resolution: void 0, acceptedAt: void 0 },
      updates: { notifiedAt: now, notifiedVerdict: verdict.verdict, updatedAt: now }
    });
    this.log.info("Claiming RecallVerdict notification", { path, claimed });
    return claimed;
  }
  /** The claimed send did not go out: hand the chance back to the next pass. */
  async releaseNotification(verdict, now) {
    const path = recallVerdictPath(verdict);
    this.log.info("Releasing RecallVerdict notification", { path });
    await this.adapter.updateDoc(path, {
      notifiedAt: this.deleteFieldValue(),
      notifiedVerdict: this.deleteFieldValue(),
      updatedAt: now
    });
  }
  /** Written on purpose without telling the home; no later pass tells them either. Same guard as the claim. */
  async silence(verdict, now) {
    const path = recallVerdictPath(verdict);
    const silenced = await this.adapter.compareAndSetDoc(path, {
      expect: { notifiedAt: void 0, silencedAt: void 0 },
      updates: { silencedAt: now, updatedAt: now }
    });
    this.log.info("Silencing RecallVerdict notification", { path, silenced });
    return silenced;
  }
  async setResolution(verdict, resolution, now) {
    const path = recallVerdictPath(verdict);
    this.log.info("Setting RecallVerdict resolution", { path, outcome: resolution.outcome, by: resolution.by });
    await this.adapter.updateDoc(path, {
      resolution: {
        outcome: resolution.outcome,
        at: now,
        by: resolution.by,
        ...resolution.note ? { note: resolution.note } : {}
      },
      // "Doesn't apply" takes back an earlier "Yes, this applies to me", so reconsidering it starts at the check.
      ...resolution.outcome === "not-my-unit" ? { acceptedAt: this.deleteFieldValue(), acceptedBy: this.deleteFieldValue() } : {},
      updatedAt: now
    });
  }
  /**
   * The homeowner said the recall applies to their unit. When the verdict was still asking whether the unit
   * is the recall's kind (`needs: type`), the answer settles that too, and the server re-evaluates on it.
   */
  async accept(verdict, now, opts) {
    const path = recallVerdictPath(verdict);
    this.log.info("Accepting RecallVerdict", { path, confirmType: opts.confirmType, by: opts.by });
    await this.adapter.updateDoc(path, {
      acceptedAt: now,
      acceptedBy: opts.by,
      ...opts.confirmType ? { typeConfirmedAt: now } : {},
      updatedAt: now
    });
  }
  /** Takes back the homeowner's resolution ("Mark Not Done", or reconsidering "Doesn't apply"): open again. */
  async reopen(verdict, now) {
    const path = recallVerdictPath(verdict);
    this.log.info("Reopening RecallVerdict", { path });
    await this.adapter.updateDoc(path, { resolution: this.deleteFieldValue(), updatedAt: now });
  }
  /** The verdict no longer stands; `notifiedAt` is kept so the homeowner is never notified twice. */
  async withdraw(verdict, reason, now) {
    const path = recallVerdictPath(verdict);
    this.log.info("Withdrawing RecallVerdict", { path, reason });
    await this.adapter.updateDoc(path, { withdrawn: { at: now, reason }, updatedAt: now });
  }
};

// src/dao/BaseSharedNameplateDao.ts
import { SharedNameplateSchema } from "@rock/types";
var BaseSharedNameplateDao = class extends BaseDao {
  constructor() {
    super("SharedNameplateDao");
  }
  async getSharedNameplate(key) {
    const path = sharedNameplatePath(key);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, SharedNameplateSchema, path, this.log) : void 0;
  }
  /** Apply a `@rock/brands` shared-nameplate plan: the row, then its deny placeholders. */
  async applySharedNameplate(plan) {
    const path = sharedNameplatePath(plan.nameplate.key);
    this.log.info("Applying SharedNameplate", { path, denials: plan.denials.length });
    await this.commitInBatches([{ kind: "set", path, data: plan.nameplate }, ...plan.denials.map(setAliasWrite)]);
  }
  /** Un-share a name: the deny placeholders it may delete, then the row. */
  async applySharedNameplateRemoval(key, deleteKeys) {
    const path = sharedNameplatePath(key);
    this.log.info("Removing SharedNameplate", { path, deleteKeys });
    await this.commitInBatches([...deleteKeys.map(deleteAliasWrite), { kind: "delete", path }]);
  }
};

// src/dao/BaseResetStateDao.ts
var BaseResetStateDao = class extends BaseDao {
  constructor() {
    super("ResetStateDao");
  }
  /**
   * Read-only for consumers (the dev enrichment triggers). The window is *written* by the `reset-dev`
   * tool, which stamps `suppressEnrichmentUntil` directly (it runs on the raw Admin SDK, outside the DAO
   * context). Suppression is active while that timestamp is in the future.
   */
  async isEnrichmentSuppressed() {
    const data = await this.adapter.getDoc(resetStatePath());
    const until = data?.suppressEnrichmentUntil;
    if (typeof until !== "string") return false;
    return new Date(until).getTime() > Date.now();
  }
};

// src/dao/BaseRockDocDao.ts
var BaseRockDocDao = class extends BaseDao {
  constructor() {
    super("RockDocDao");
  }
  async getRockDoc(docId) {
    const path = rockDocPath(docId);
    const data = await this.adapter.getDoc(path);
    return data;
  }
  async setRockDoc(docId, data) {
    const path = rockDocPath(docId);
    this.log.info("Setting RockDoc", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateRockDoc(docId, updates) {
    const path = rockDocPath(docId);
    this.log.info("Updating RockDoc", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async getConsiderationDoc(docId) {
    const path = considerationDocPath(docId);
    const data = await this.adapter.getDoc(path);
    return data;
  }
  async setConsiderationDoc(docId, data) {
    const path = considerationDocPath(docId);
    this.log.info("Setting ConsiderationDoc", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateConsiderationDoc(docId, updates) {
    const path = considerationDocPath(docId);
    this.log.info("Updating ConsiderationDoc", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async getLessonDoc(docId) {
    const path = lessonDocPath(docId);
    const data = await this.adapter.getDoc(path);
    return data;
  }
  async setLessonDoc(docId, data) {
    const path = lessonDocPath(docId);
    this.log.info("Setting LessonDoc", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateLessonDoc(docId, updates) {
    const path = lessonDocPath(docId);
    this.log.info("Updating LessonDoc", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async getTaskDoc(docId) {
    const path = taskDocPath(docId);
    const data = await this.adapter.getDoc(path);
    return data;
  }
  async setTaskDoc(docId, data) {
    const path = taskDocPath(docId);
    this.log.info("Setting TaskDoc", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateTaskDoc(docId, updates) {
    const path = taskDocPath(docId);
    this.log.info("Updating TaskDoc", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseRockManualsJobDao.ts
import { RockManualsJobSchema } from "@rock/types";
var MANUALS_JOB_PARKED_AT = "9999-12-31T00:00:00.000Z";
var BaseRockManualsJobDao = class extends BaseDao {
  constructor() {
    super("RockManualsJobDao");
  }
  async getRockManualsJob(jobId) {
    const path = rockManualsJobRunPath(jobId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RockManualsJobSchema, path, this.log) : void 0;
  }
  async setRockManualsJob(jobId, data) {
    const path = rockManualsJobRunPath(jobId);
    this.log.info("Setting RockManualsJob", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateRockManualsJob(jobId, updates) {
    const path = rockManualsJobRunPath(jobId);
    this.log.info("Updating RockManualsJob", { path });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Terminal resolution of a successful hunt: its output was consumed (an app-visible document was
   * published, or the model was archived), so the job leaves `succeeded` — which now unambiguously
   * means "awaiting review" and is counted directly by the admin dashboard. Also re-asserts the
   * FAR_FUTURE parking so the entry can never be nominated by the worker's `nextAttemptAt` claim
   * query, whatever its history.
   */
  async markReviewed(jobId) {
    const path = rockManualsJobRunPath(jobId);
    this.log.info("Marking RockManualsJob reviewed", { path });
    const updates = {
      status: "reviewed",
      nextAttemptAt: MANUALS_JOB_PARKED_AT,
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Reopen a `reviewed` job — e.g. its published document was unpublished — so its output counts as
   * awaiting review again. Stays parked: reopening the review doesn't resume the hunt.
   */
  async reopenForReview(jobId) {
    const path = rockManualsJobRunPath(jobId);
    this.log.info("Reopening RockManualsJob for review", { path });
    const updates = {
      status: "succeeded",
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Admin stop: halt a job's FUTURE attempts. Stamps `cancelledAt` — the field the worker's `isClaimable`
   * gate actually checks, so the cancel holds even if an in-flight attempt later re-parks `status` to
   * `pending` on its way out — sets `cancelled` for the UI, and parks `nextAttemptAt` so the due-now claim
   * query never nominates it. Does NOT interrupt an attempt already running; that one finishes, but no
   * further attempt is claimed. Re-enqueue (Re-run search / offer) clears `cancelledAt` and revives it.
   */
  async cancelJob(jobId) {
    const path = rockManualsJobRunPath(jobId);
    const current = await this.getRockManualsJob(jobId);
    if (current?.status !== "pending" && current?.status !== "running") {
      this.log.info("Skipping cancel of a non-active RockManualsJob", { path, status: current?.status });
      return;
    }
    this.log.info("Cancelling RockManualsJob", { path });
    const now = (/* @__PURE__ */ new Date()).toISOString();
    const updates = {
      status: "cancelled",
      cancelledAt: now,
      nextAttemptAt: MANUALS_JOB_PARKED_AT,
      updatedAt: now
    };
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseRoomDao.ts
import { RoomSchema } from "@rock/types";
var BaseRoomDao = class extends BaseDao {
  constructor() {
    super("RoomDao");
  }
  async getRoom(homeId, roomId) {
    const path = roomPath(homeId, roomId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RoomSchema, path, this.log) : void 0;
  }
  async setRoom(homeId, roomId, data) {
    const path = roomPath(homeId, roomId);
    this.log.info("Setting Room", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateRoom(homeId, roomId, updates) {
    const path = roomPath(homeId, roomId);
    this.log.info("Updating Room", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseRoomEnhancementDao.ts
import { RoomEnhancementSchema } from "@rock/types";
var BaseRoomEnhancementDao = class extends BaseDao {
  constructor() {
    super("RoomEnhancementDao");
  }
  async getRoomEnhancement(homeId, roomId, enhancementId) {
    const path = roomEnhancementPath(homeId, roomId, enhancementId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, RoomEnhancementSchema, path, this.log) : void 0;
  }
  async setRoomEnhancement(homeId, roomId, enhancementId, data) {
    const path = roomEnhancementPath(homeId, roomId, enhancementId);
    this.log.info("Setting RoomEnhancement", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateRoomEnhancement(homeId, roomId, enhancementId, updates) {
    const path = roomEnhancementPath(homeId, roomId, enhancementId);
    this.log.info("Updating RoomEnhancement", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  async deleteRoomEnhancement(homeId, roomId, enhancementId) {
    const path = roomEnhancementPath(homeId, roomId, enhancementId);
    this.log.info("Deleting RoomEnhancement", { path });
    await this.adapter.deleteDoc(path);
  }
};

// src/dao/BaseSpaceDao.ts
import { SpaceSchema } from "@rock/types";
var BaseSpaceDao = class extends BaseDao {
  constructor() {
    super("SpaceDao");
  }
  async getSpace(spaceId) {
    const path = spacePath(spaceId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, SpaceSchema, path, this.log) : void 0;
  }
  /** Whether the doc exists at all, parseable or not — `getSpace` returns undefined for both. */
  async hasSpace(spaceId) {
    const path = spacePath(spaceId);
    return !!await this.adapter.getDoc(path);
  }
  async setSpace(spaceId, data) {
    const path = spacePath(spaceId);
    this.log.info("Setting Space", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateSpace(spaceId, updates) {
    const path = spacePath(spaceId);
    this.log.info("Updating Space", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseSystemInfoDao.ts
import { SystemInfoSchema } from "@rock/types";
var BaseSystemInfoDao = class extends BaseDao {
  constructor() {
    super("SystemInfoDao");
  }
  async getSystemInfo(homeId, infoId) {
    const path = systemInfoPath(homeId, infoId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, SystemInfoSchema, path, this.log) : void 0;
  }
  async setSystemInfo(homeId, infoId, data) {
    const path = systemInfoPath(homeId, infoId);
    this.log.info("Setting SystemInfo", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateSystemInfo(homeId, infoId, updates) {
    const path = systemInfoPath(homeId, infoId);
    this.log.info("Updating SystemInfo", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};

// src/dao/BaseTaskDao.ts
import { TaskSchema } from "@rock/types";
var BaseTaskDao = class extends BaseDao {
  constructor() {
    super("TaskDao");
  }
  async getTask(homeId, taskId) {
    const path = taskPath(homeId, taskId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, TaskSchema, path, this.log) : void 0;
  }
  async setTask(homeId, taskId, data) {
    const path = taskPath(homeId, taskId);
    this.log.info("Setting Task", { path, data });
    await this.adapter.setDoc(path, data);
  }
  async updateTask(homeId, taskId, updates) {
    const path = taskPath(homeId, taskId);
    this.log.info("Updating Task", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Sets (or clears) the task's notes. Empty notes are removed with the delete sentinel rather than
   * written as `undefined`, which an update silently ignores. Mirrors
   * `BaseHomeTaskSubscriptionDao.setSubscriptionTaskNotes`, which the same save path calls to keep
   * future generated tasks carrying the latest notes.
   */
  async setTaskNotes(homeId, taskId, notes) {
    const path = taskPath(homeId, taskId);
    this.log.info("Setting Task notes", { path, hasNotes: !!notes });
    await this.adapter.updateDoc(path, {
      notes: notes || this.adapter.deleteFieldValue(),
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    });
  }
  async markTaskComplete(homeId, taskId, by, completion = {}) {
    const { supplyChanges, coveredEquipmentIds } = completion;
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Marking task complete", { homeId, taskId, by, supplyChanges, coveredEquipmentIds });
    await this.updateTask(homeId, taskId, {
      status: "completed",
      completedAt: now,
      completedBy: by,
      updatedAt: now,
      ...supplyChanges?.length ? { supplyChanges } : {},
      ...coveredEquipmentIds?.length ? { coveredEquipmentIds } : {}
    });
  }
  async markTaskNotComplete(homeId, taskId) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Marking task not complete", { homeId, taskId });
    await this.adapter.updateDoc(taskPath(homeId, taskId), {
      status: "pending",
      completedAt: this.adapter.deleteFieldValue(),
      completedBy: this.adapter.deleteFieldValue(),
      supplyChanges: this.adapter.deleteFieldValue(),
      coveredEquipmentIds: this.adapter.deleteFieldValue(),
      updatedAt: now
    });
  }
  async setTaskContact(homeId, taskId, contactId) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Setting task contact", { homeId, taskId, contactId });
    await this.updateTask(homeId, taskId, { contactId, updatedAt: now });
  }
  // Image writes are scoped to a single image's map entry (`images.<id>`) plus array transforms
  // on `imageOrder`, so concurrent writers (upload writeback, picture saves) compose instead of
  // clobbering each other. Never write the whole `images` field — see rock-types
  // imageCollection.ts for the rationale.
  /**
   * Adds one image (or fully replaces the entry with the same id) and appends its id to the
   * display order (no-op when already present).
   */
  async putImage(homeId, taskId, image) {
    const path = taskPath(homeId, taskId);
    this.log.info("Putting Task image", { path, imageId: image.id });
    await this.adapter.updateDoc(path, {
      [`images.${image.id}`]: image,
      imageOrder: this.adapter.arrayUnionValue(image.id),
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    });
  }
  /** Removes one image from the map and its id from the display order. */
  async removeImage(homeId, taskId, imageId) {
    const path = taskPath(homeId, taskId);
    this.log.info("Removing Task image", { path, imageId });
    await this.adapter.updateDoc(path, {
      [`images.${imageId}`]: this.adapter.deleteFieldValue(),
      imageOrder: this.adapter.arrayRemoveValue(imageId),
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    });
  }
  /**
   * Patches individual fields on one image (e.g. `title`, `notes`). Keys explicitly set to
   * `undefined` are cleared; absent keys are untouched.
   */
  async updateImageFields(homeId, taskId, imageId, fields) {
    const path = taskPath(homeId, taskId);
    this.log.info("Updating Task image fields", { path, imageId, fields });
    const updates = { updatedAt: (/* @__PURE__ */ new Date()).toISOString() };
    for (const [key, value] of Object.entries(fields)) {
      updates[`images.${imageId}.${key}`] = value === void 0 ? this.adapter.deleteFieldValue() : value;
    }
    await this.adapter.updateDoc(path, updates);
  }
  async clearTaskContact(homeId, taskId) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    this.log.info("Clearing task contact", { homeId, taskId });
    await this.adapter.updateDoc(taskPath(homeId, taskId), {
      contactId: this.adapter.deleteFieldValue(),
      updatedAt: now
    });
  }
};

// src/dao/BaseTaskGenerationJobRunDao.ts
import { TaskGenerationJobRunSchema } from "@rock/types";
var BaseTaskGenerationJobRunDao = class extends BaseDao {
  constructor() {
    super("TaskGenerationJobRunDao");
  }
  async getTaskGenerationJobRun(runId) {
    const path = taskGenerationJobRunPath(runId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, TaskGenerationJobRunSchema, path, this.log) : void 0;
  }
  async setTaskGenerationJobRun(runId, data) {
    const path = taskGenerationJobRunPath(runId);
    this.log.info("Setting TaskGenerationJobRun", { path });
    await this.adapter.setDoc(path, withExpireAt(data));
  }
  async updateTaskGenerationJobRun(runId, updates) {
    const path = taskGenerationJobRunPath(runId);
    this.log.info("Updating TaskGenerationJobRun", { path, updates });
    await this.adapter.updateDoc(path, withExpireAt(updates));
  }
};

// src/dao/BaseTaskTypeDao.ts
import { TaskTypeSchema } from "@rock/types";
var BaseTaskTypeDao = class extends BaseDao {
  constructor() {
    super("TaskTypeDao");
  }
  async getTaskType(typeId) {
    const path = taskTypePath(typeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, TaskTypeSchema, path, this.log) : void 0;
  }
  /** Whether a TaskType doc exists at all, parseable or not — `getTaskType` returns undefined for both. */
  async hasTaskType(typeId) {
    const path = taskTypePath(typeId);
    return !!await this.adapter.getDoc(path);
  }
  async setTaskType(typeId, data) {
    const path = taskTypePath(typeId);
    this.log.info("Setting TaskType", { path });
    await this.adapter.setDoc(path, data);
  }
  async updateTaskType(typeId, updates) {
    const path = taskTypePath(typeId);
    this.log.info("Updating TaskType", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
  /**
   * Apply a Notion sync to a task type, clearing `effort` when the page no longer carries it.
   *
   * A plain `updateDoc` cannot do this: the server adapter runs with `ignoreUndefinedProperties`, so
   * `{ effort: undefined }` is a silent no-op and the doc would keep a size the author removed. The
   * lesson catalog's `applyLessonTypeSync` is the same fix.
   */
  async applyTaskTypeSync(typeId, updates) {
    const path = taskTypePath(typeId);
    this.log.info("Applying TaskType sync", { path, updates });
    await this.adapter.updateDoc(path, { ...updates, effort: updates.effort ?? this.deleteFieldValue() });
  }
};

// src/dao/BaseUserDao.ts
import { UserSchema } from "@rock/types";
var BaseUserDao = class extends BaseDao {
  constructor() {
    super("UserDao");
  }
  async getUser(userId) {
    const path = userPath(userId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, UserSchema, path, this.log) : void 0;
  }
  /** Creates the user doc. To CHANGE an existing one, use {@link updateUser} — see why there. */
  async setUser(userId, data) {
    const path = userPath(userId);
    this.log.info("Setting User", { path });
    await this.adapter.setDoc(path, data);
  }
  /**
   * Patches individual user fields. Prefer this over {@link setUser} for every edit: the user doc has
   * several independent writers — the auth reconcile on each sign-in and token refresh, the profile,
   * display and privacy screens, the supplier picker — and a whole-document write built from a
   * screen's rendered value reverts whatever landed since that value was read.
   *
   * `toFieldPaths` is doing real work here: the keys inside `display` have different owners — the
   * UI-mode picker and the weekend-start picker are siblings, and the auth reconcile re-derives
   * `display.timezone` underneath both — so the group is flattened rather than replaced.
   */
  async updateUser(userId, updates) {
    const path = userPath(userId);
    const fieldPaths = this.toFieldPaths(updates);
    this.log.info("Updating User", { path, fields: Object.keys(fieldPaths) });
    await this.adapter.updateDoc(path, fieldPaths);
  }
  /**
   * Records ONE setup-checklist item's outcome in the `setupChecklist` map — a dot-path write for
   * the same reason {@link updateUser} flattens: the user doc has several independent writers, and
   * a whole-map write would drop items resolved on another device. The marker goes in whole rather
   * than per-field: a partial entry fails the User parse and would poison the doc app-wide.
   *
   * User items only — these are lessons, so they're remembered for every home the user owns and
   * survive a reinstall. A home's own items live on the home (BaseHomeDao.putSetupChecklistMarker).
   */
  async putSetupChecklistMarker(userId, item, marker) {
    const path = userPath(userId);
    this.log.info("Putting User setup checklist marker", { path, item, outcome: marker.outcome });
    await this.adapter.updateDoc(path, { [`setupChecklist.${item}`]: marker });
  }
  async deleteUser(userId) {
    const path = userPath(userId);
    this.log.info("Deleting User", { path });
    await this.adapter.updateDoc(path, { deleted: true });
  }
};

// src/dao/BaseUserLimitsDao.ts
import { UserLimitsConfigSchema, UserLimitsSchema, resolveUserLimit } from "@rock/types";
import { todayLocalDate } from "@rock/util";
var BaseUserLimitsDao = class extends BaseDao {
  constructor() {
    super("UserLimitsDao");
  }
  async getUserLimits(userId) {
    const path = userLimitsPath(userId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, UserLimitsSchema, path, this.log) : void 0;
  }
  async setUserLimits(userId, data) {
    const path = userLimitsPath(userId);
    this.log.info("Setting UserLimits", { path });
    await this.adapter.setDoc(path, data);
  }
  /** Reads the editable cap-values singleton at `app/user-limits-config` (undefined until an admin overrides a default). */
  async getLimitsConfig() {
    const path = appUserLimitsConfigPath();
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, UserLimitsConfigSchema, path, this.log) : void 0;
  }
  /** A key's effective daily cap: the `app/user-limits-config` override if present, else the code default. */
  async getLimit(key) {
    return resolveUserLimit(await this.getLimitsConfig(), key);
  }
  /**
   * Reserve one of today's slots for `key`. Reads the user's counter + the effective cap (config override
   * or code default) and — only if under the cap — increments via read-modify-write `setDoc` (NOT
   * `updateDoc`, which NOT_FOUNDs the lazily-created doc), spreading `...limits` so the OTHER key's counter
   * is never clobbered. Over the cap → `{ allowed: false }` WITHOUT incrementing.
   *
   * Call this at the point of committing to the PAID work, so a later failure still consumes a slot
   * (cost-accurate). Server-only (db-server, whose override runs the read-modify-write in a transaction so
   * a burst of parallel calls cannot overshoot the cap) — keep it OUT of shared runtime code so the
   * rock-gpt CLI stays exempt. The day is the server's UTC day (`todayLocalDate()`).
   */
  async reserveDaily(userId, key) {
    const [limits, limit] = await Promise.all([this.getUserLimits(userId), this.getLimit(key)]);
    const next = takeDailySlot(userId, limits, key, limit);
    if (!next) return { allowed: false, limit };
    await this.setUserLimits(userId, next);
    return { allowed: true, limit };
  }
};
function takeDailySlot(userId, limits, key, limit) {
  const today = todayLocalDate();
  const counter = limits?.[key];
  const usedToday = counter?.day === today ? counter.count : 0;
  if (usedToday >= limit) return void 0;
  return {
    ...limits,
    object: "user-limits",
    schema: 1,
    id: userId,
    [key]: { day: today, count: usedToday + 1 },
    updatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}

// src/dao/BaseUserNotificationDao.ts
import { UserNotificationSchema } from "@rock/types";
var BaseUserNotificationDao = class extends BaseDao {
  constructor() {
    super("UserNotificationDao");
  }
  /** Producer entry point: write one notification onto the bus. */
  async createUserNotification(notification) {
    const path = userNotificationPath(notification.id);
    this.log.info("Creating UserNotification", { path, type: notification.type });
    await this.adapter.setDoc(path, notification);
  }
  async getUserNotification(userNotificationId) {
    const path = userNotificationPath(userNotificationId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, UserNotificationSchema, path, this.log) : void 0;
  }
  /** Records one channel's send/skip decision back on the intake doc (channel-scoped, non-clobbering). */
  async setChannelOutcome(userNotificationId, channel, outcome) {
    const path = userNotificationPath(userNotificationId);
    this.log.info("Setting UserNotification channel outcome", { path, channel, sent: outcome.sent });
    await this.adapter.updateDoc(path, { [channel]: outcome });
  }
  /** Records MailerSend delivery details under the bus doc, keyed by messageId. */
  async setEmailReceipt(userNotificationId, messageId, receipt) {
    const path = userNotificationEmailReceiptPath(userNotificationId, messageId);
    this.log.info("Setting EmailReceipt", { path });
    await this.adapter.setDoc(path, receipt);
  }
  /** Records Expo push delivery details under the bus doc, keyed by ticketId. */
  async setPushReceipt(userNotificationId, ticketId, receipt) {
    const path = userNotificationPushReceiptPath(userNotificationId, ticketId);
    this.log.info("Setting PushReceipt", { path });
    await this.adapter.setDoc(path, receipt);
  }
};

// src/dao/BaseUserRoleDao.ts
var BaseUserRoleDao = class extends BaseDao {
  constructor() {
    super("UserRoleDao");
  }
  async getUserRoles(userId) {
    return await this.adapter.getDoc(userRolesPath(userId)) ?? {};
  }
  async isAdmin(userId) {
    const roles = await this.getUserRoles(userId);
    return roles.admin === true;
  }
  /**
   * Grants or revokes a single role, merging so other roles on the doc are untouched. Revoking sets the
   * key to `false` (a falsy value, which `hasRole`'s strict `=== true` check treats as not-granted) rather
   * than deleting the field — see CLAUDE.md's field-clearing guidance.
   */
  async setRole(userId, role, enabled) {
    this.log.info("Setting user role", { userId, role, enabled });
    await this.setDoc(userRolesPath(userId), { [role]: enabled }, { merge: true });
  }
  /** Convenience for the most common role. */
  async setAdmin(userId, enabled) {
    await this.setRole(userId, "admin", enabled);
  }
};

// src/dao/BaseUserTaskScreenConfigDao.ts
import { UserTaskScreenConfigSchema } from "@rock/types";
var BaseUserTaskScreenConfigDao = class extends BaseDao {
  constructor() {
    super("UserTaskScreenConfigDao");
  }
  async getConfig(userId, taskTypeId) {
    const path = userTaskScreenConfigPath(userId, taskTypeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, UserTaskScreenConfigSchema, path, this.log) : void 0;
  }
  /** Saves the user's full section arrangement (order + any explicit show/hide) for this task type. */
  async setArrangement(userId, taskTypeId, sections) {
    await this.mergeConfig(userId, taskTypeId, { sections });
  }
  /**
   * Discards the user's arrangement for this task type, reverting to the resolved default. Drops the
   * `sections` field (rather than the whole doc) — consistent with how config docs are reset
   * elsewhere; its absence reads back as "no arrangement".
   */
  async resetConfig(userId, taskTypeId) {
    await this.mergeConfig(userId, taskTypeId, { sections: this.deleteFieldValue() });
  }
  async mergeConfig(userId, taskTypeId, partial) {
    const path = userTaskScreenConfigPath(userId, taskTypeId);
    this.log.info("Setting UserTaskScreenConfig", { path, partial });
    await this.adapter.setDoc(
      path,
      {
        object: "user-task-screen-config",
        schema: 1,
        id: taskTypeId,
        userId,
        updatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        ...partial
      },
      { merge: true }
    );
  }
};

// src/dao/BaseWeekendFillDao.ts
import { WeekendFillSchema } from "@rock/types";
var BaseWeekendFillDao = class extends BaseDao {
  constructor() {
    super("WeekendFillDao");
  }
  async getWeekendFill(homeId) {
    const path = weekendFillPath(homeId);
    const data = await this.adapter.getDoc(path);
    return data ? parseWithSchema(data, WeekendFillSchema, path, this.log) : void 0;
  }
  async setWeekendFill(homeId, data) {
    const path = weekendFillPath(homeId);
    this.log.info("Setting WeekendFill", { path, lastFilledWeekend: data.lastFilledWeekend });
    await this.adapter.setDoc(path, data);
  }
  /**
   * Books one or more of the marker's moments. A field patch, never the whole doc: three hourly
   * sweeps each own a moment on the same marker, and a whole-doc write from one would drop what
   * another booked since it read.
   */
  async updateWeekendSchedule(homeId, updates) {
    const path = weekendFillPath(homeId);
    this.log.info("Updating WeekendFill schedule", { path, updates });
    await this.adapter.updateDoc(path, updates);
  }
};
export {
  BaseAppStatusDao,
  BaseAppliesToDraftResultDao,
  BaseAppliesToOwnerDao,
  BaseBrandAliasDao,
  BaseBrandDao,
  BaseBrandMergeDao,
  BaseBrandRequestDao,
  BaseBrandResearchDao,
  BaseBrandSearchIndexDao,
  BaseBrandSourceDao,
  BaseChatConversationDao,
  BaseCompanyDao,
  BaseConsiderationDao,
  BaseConsiderationTypeDao,
  BaseContactDao,
  BaseCustomEquipmentTypeDao,
  BaseCustomTaskTypeDao,
  BaseDao,
  BaseDeviceDao,
  BaseDocumentCoverageDao,
  BaseDocumentSearchDao,
  BaseDomainEventDao,
  BaseEquipmentDao,
  BaseEquipmentImageSearchRequestDao,
  BaseEquipmentRefreshDao,
  BaseEquipmentTestLibraryDao,
  BaseEquipmentTypeCandidateDao,
  BaseEquipmentTypeDao,
  BaseEquipmentTypeFamilyDao,
  BaseEquipmentTypeRefreshDao,
  BaseFeedbackSubmissionDao,
  BaseFolderDao,
  BaseGuideDao,
  BaseGuideHelpCacheDao,
  BaseGuideHelpRequestDao,
  BaseGuideStarterDao,
  BaseHomeDao,
  BaseHomeEvalJobDao,
  BaseHomeEvalResultDao,
  BaseHomeEvalTriggerDao,
  BaseHomeInviteDao,
  BaseHomeMemberDao,
  BaseHomeQuestionDao,
  BaseHomeTaskSubscriptionDao,
  BaseImageWritebackDao,
  BaseInAppNotificationDao,
  BaseInfoTypeDao,
  BaseLearnCacheDao,
  BaseLearnRequestDao,
  BaseLessonDao,
  BaseLessonTypeDao,
  BaseModelDao,
  BaseModelDocumentCandidateDao,
  BaseModelDocumentDao,
  BaseModelNumberHelpCacheDao,
  BaseModelNumberHelpRequestDao,
  BaseModelSpellingDao,
  BaseNotificationConfigDao,
  BaseNotionWebhookEventDao,
  BasePlanReviewDao,
  BaseProcessHowOftenResultDao,
  BasePropertyLookupRequestDao,
  BaseRecallDao,
  BaseRecallJobDao,
  BaseRecallMatchDao,
  BaseRecallTopicDao,
  BaseRecallVerdictDao,
  BaseResetStateDao,
  BaseRockDocDao,
  BaseRockManualsJobDao,
  BaseRoomDao,
  BaseRoomEnhancementDao,
  BaseSharedNameplateDao,
  BaseSpaceDao,
  BaseSystemInfoDao,
  BaseTaskDao,
  BaseTaskGenerationJobRunDao,
  BaseTaskTypeDao,
  BaseUserDao,
  BaseUserLimitsDao,
  BaseUserNotificationDao,
  BaseUserRoleDao,
  BaseUserTaskScreenConfigDao,
  BaseWeekendFillDao,
  DRAFT_ROOT,
  DraftLayer,
  EQUIPMENT_TYPE_PRESERVED_ON_PUBLISH,
  FirestoreDocPathSchema,
  LIVE_RETENTION_DAYS,
  MANUALS_JOB_PARKED_AT,
  RECLASSIFIABLE_RECALL_STATUSES,
  RecallChangedError,
  aiHelpCollection,
  aiTasksCollection,
  appBrandSearchIndexPath,
  appCollection,
  appDefaultEquipmentGuidePath,
  appEquipmentConfigObjectsCollection,
  appEquipmentConfigPath,
  appNotificationConfigPath,
  appRecallsStatePath,
  appStatusCollection,
  appStatusDocPath,
  appTaskScreenConfigPath,
  appUserLimitsConfigPath,
  appliesToDraftResultPath,
  appliesToDraftResultsCollection,
  brandAliasPath,
  brandAliasesCollection,
  brandMergePath,
  brandMergesCollection,
  brandPath,
  brandRequestPath,
  brandRequestsCollection,
  brandResearchCollection,
  brandResearchPath,
  brandSourcePath,
  brandSourcesCollection,
  brandsCollection,
  chatConversationPath,
  chatConversationsCollection,
  companiesCollection,
  companyPath,
  computeDraftStatus,
  considerationDocPath,
  considerationDocsCollection,
  considerationPath,
  considerationTypePath,
  considerationTypesCollection,
  considerationsCollection,
  considerationsCollectionGroupName,
  contactPath,
  contactsCollection,
  contactsCollectionGroupName,
  customEquipmentTypePath,
  customEquipmentTypesCollection,
  customEquipmentTypesCollectionGroupName,
  customTaskTypePath,
  customTaskTypesCollection,
  customTaskTypesCollectionGroupName,
  devicesCollectionGroupName,
  documentCoverageCollection,
  documentCoveragePath,
  documentSearchPath,
  documentSearchesCollection,
  domainEventPath,
  domainEventsCollection,
  draftFlowPath,
  draftFlowsCollection,
  equipmentCollection,
  equipmentCollectionGroupName,
  equipmentImageSearchRequestPath,
  equipmentImageSearchRequestsCollection,
  equipmentLearnRequestPath,
  equipmentLearnRequestsCollection,
  equipmentPath,
  equipmentRefreshPath,
  equipmentRefreshesCollection,
  equipmentTestLibraryCollection,
  equipmentTestLibraryEntryPath,
  equipmentTypeCandidatePath,
  equipmentTypeCandidatesCollection,
  equipmentTypeFamiliesCollection,
  equipmentTypeFamilyPath,
  equipmentTypeObjectsCollection,
  equipmentTypePath,
  equipmentTypeRefreshPath,
  equipmentTypeRefreshesCollection,
  equipmentTypesCollection,
  feedbackCollection,
  feedbackEntryPath,
  folderPath,
  foldersCollection,
  fromDraftPath,
  getDaoContext,
  guideHelpCacheCollection,
  guideHelpCacheEntryPath,
  guideHelpRequestPath,
  guideHelpRequestsCollection,
  guidePath,
  guideStarterPath,
  guideStartersCollection,
  guideStartersCollectionGroupName,
  guideVisitPath,
  guideVisitsCollection,
  hasUnpublishedChanges,
  homeEvalJobRunPath,
  homeEvalJobRunsCollection,
  homeEvalResultPath,
  homeEvalResultsCollection,
  homeEvalTriggerPath,
  homeEvalTriggersCollection,
  homeInvitePath,
  homeInvitesCollection,
  homeInvitesCollectionGroupName,
  homeMemberPath,
  homeMembersCollection,
  homePath,
  homeQuestionPath,
  homeQuestionsCollection,
  homeRecentlyViewedCollection,
  homeRecentlyViewedPath,
  homeSpacePath,
  homeSpacesCollection,
  homeTaskSubscriptionPath,
  homeTaskSubscriptionsCollection,
  homesCollection,
  infoTypePath,
  infoTypesCollection,
  initializeDao,
  jobsCollection,
  learnCacheCollection,
  learnCacheEntryPath,
  legacyRecallVerdictPath,
  lessonDocPath,
  lessonDocsCollection,
  lessonPath,
  lessonTypePath,
  lessonTypesCollection,
  lessonsCollection,
  lessonsCollectionGroupName,
  liveRetentionEnd,
  matchesExpected,
  mergeConfig,
  modelDetailsCollection,
  modelDocumentCandidatePath,
  modelDocumentCandidatesCollection,
  modelDocumentCandidatesCollectionGroupName,
  modelDocumentPath,
  modelDocumentsCollection,
  modelNumberHelpCacheCollection,
  modelNumberHelpCacheEntryPath,
  modelNumberHelpRequestPath,
  modelNumberHelpRequestsCollection,
  modelPath,
  modelSpellingPath,
  modelSpellingsCollection,
  modelsCollection,
  notificationConfigCollection,
  notificationConfigCollectionGroupName,
  notificationConfigPath,
  notificationPath,
  notificationsCollection,
  notionWebhookEventPath,
  notionWebhookEventsCollection,
  parseWithSchema,
  planReviewPath,
  planReviewsCollection,
  processHowOftenResultPath,
  processHowOftenResultsCollection,
  propertyLookupRequestPath,
  propertyLookupRequestsCollection,
  pushReceiptsCollectionGroupName,
  recallJobPath,
  recallJobsCollection,
  recallKeyPath,
  recallKeysCollection,
  recallMatchPath,
  recallMatchesCollection,
  recallMatchesCollectionGroupName,
  recallPath,
  recallTopicPath,
  recallTopicsCollection,
  recallVerdictPath,
  recallVerdictsCollection,
  recallVerdictsCollectionGroupName,
  recallsCollection,
  resetStatePath,
  resolveTypeDefaults,
  rockDocPath,
  rockDocsCollection,
  rockManualsJobRunPath,
  rockManualsJobRunsCollection,
  roomEnhancementPath,
  roomEnhancementsCollection,
  roomPath,
  roomsCollection,
  sharedNameplatePath,
  sharedNameplatesCollection,
  spaceFlowPath,
  spaceObjectsCollection,
  spacePath,
  spacesCollection,
  stampDraft,
  stripDraft,
  systemCollection,
  systemInfoCollection,
  systemInfoPath,
  takeDailySlot,
  taskDocPath,
  taskDocsCollection,
  taskGenerationJobRunPath,
  taskGenerationJobRunsCollection,
  taskPath,
  taskSubscriptionsCollectionGroupName,
  taskTypePath,
  taskTypesCollection,
  tasksCollection,
  tasksCollectionGroupName,
  toDraftPath,
  userAuthEventsCollection,
  userDevicePath,
  userDevicesCollection,
  userLimitsCollection,
  userLimitsPath,
  userNotificationEmailReceiptPath,
  userNotificationEmailReceiptsCollection,
  userNotificationPath,
  userNotificationPushReceiptPath,
  userNotificationPushReceiptsCollection,
  userNotificationsCollection,
  userPath,
  userRolesCollection,
  userRolesPath,
  userTaskScreenConfigCollection,
  userTaskScreenConfigPath,
  usersCollection,
  weekendFillPath,
  weekendFillsCollection,
  withExpireAt
};
//# sourceMappingURL=index.js.map